export const templateSizeGuide = () => {
  return `
  <html lang="es">

  <head>
    <link rel="stylesheet" href="https://www.decathlon.es/static/landings/guia-de-tallas/style.css">
    <style>
      table {
        margin-left: 143px;
      }
  
      table thead tr th:first-child,
      table tbody tr td:first-child {
        position: absolute;
        left: 14px;
        width: 145px;
      }
  
      .th-bici {
        height: 58px;
        padding-top: 20px !important;
      }
  
      .table-responsive,
      .table-bordered {
        border: 0;
      }
    </style>
  
  <body>
    <div id="size-guide-container" class="container">
      <div class="row banner-guia-de-tallas">
        <div class="col-xs-12">
          <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading" role="tab" id="headingOne">
                <a onclick="handleEventAnalytics('guia-de-tallas','desplegable', 'como-saber-tus-medidas')" role="button"
                  data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false"
                  aria-controls="collapseOne">
                  <div class="row">
                    <div class="banner-guia-de-tallas__titulo col-xs-12 col-sm-4 col-md-3">
                      <h1>Guía de tallas</h1>
                      <h2 class="panel-title">Como saber tus medidas</h2>
                      <span title="info" class="icon icon-i-roll info-scroll"></span>
                      <span title="close" class="icon icon-x-line close-scroll"></span>
                    </div>
                    <div class="col-sm-8 col-md-9">
                    </div>
                  </div>
                </a>
              </div>
  
              <div id="collapseOne" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne">
                <div class="panel-body">
  
                  <div class="row">
                    <div class="col-xs-12 col-sm-5 col-md-4 col-lg-3">
                      <div class="row">
                        <div id="silueta" class=" col-xs-8 col-sm-12">
                          <img src="https://www.decathlon.es/static/landings/guia-de-tallas/img/silueta_tallas_mobile_375px.png"
                            class="img-silueta-mobile" alt="imagen silueta">
                          <img src="https://www.decathlon.es/static/landings/guia-de-tallas/img/silueta_tallas_desktop_1.png"
                            class="img-silueta-desktop" alt="imagen silueta">
                        </div>
                        <div id="siluetas" class="col-xs-4 col-sm-0">
                          <p class="numero-silueta" id="altura"><span>1.</span> Altura</p>
                          <p class="numero-silueta" id="cabeza"><span>2.</span> Cabeza</p>
                          <p class="numero-silueta" id="pecho"><span>3.</span> Pecho</p>
                          <p class="numero-silueta" id="debajo-pecho"><span>4.</span> Debajo del
                            Pecho</p>
                          <p class="numero-silueta" id="cintura"><span>5.</span> Cintura</p>
                          <p class="numero-silueta" id="cadera"><span>6.</span> Cadera</p>
                          <p class="numero-silueta" id="mano"><span>7.</span> Mano</p>
                          <p class="numero-silueta" id="pie"><span>8.</span> Pie</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-7 col-md-8 col-lg-9">
                      <ul>
                        <li class="altura lista-cuerpo">
                          <h3><span>1.</span> Altura</h3>
                          <p>Cuando esté descalzo/a, mídele justo desde la coronilla hasta el
                            suelo..</p>
                        </li>
                        <li class="cabeza lista-cuerpo">
                          <h3><span>2.</span> Cabeza</h3>
                          <p>Coloca una cinta métrica por encima de las cejas. Asegúrate
                            de que está paralela al suelo.</p>
                        </li>
                        <li class="pecho lista-cuerpo">
                          <h3><span>3.</span> Pecho</h3>
                          <p>Coloca una cinta métrica en le mayor perímetro del pecho. Asegúrate
                            de que está paralela al suelo. Levanta la cabeza y mide respirando
                            normalmente.</p>
                        </li>
                        <li class="debajo-pecho lista-cuerpo">
  
                          <h3><span>4.</span> Debajo Del Pecho </h3>
                          <p>Coloca una cinta mñetrica
                            justo por debajo del
                            pecho. Asegúrate de que está paralela al suelo. Levanta la caveza y
                            mide resporando normalmente
                          </p>
                        </li>
                        <li class="cintura lista-cuerpo">
                          <h3><span>5.</span> Cintura</h3>
                          <p>Coloca una cinta métrica sobre el ombligo en el perímetro más
                            pequeño de la cintura. Levanta la cabeza y mide respirando
                            normalmente.</p>
                        </li>
                        <li class="cadera lista-cuerpo">
                          <h3><span>6.</span> Cadera</h3>
                          <p>Toma la medida en el mayor perímetro.</p>
                        </li>
                        <li class="mano lista-cuerpo">
                          <h3><span>7.</span> Mano</h3>
                          <p>Coloca una cinta métrica en el pliegue del pulgar. Da una vuelta a
                            la palma con la cinta.</p>
                        </li>
                        <li class="pie lista-cuerpo">
                          <h3><span>8.</span> Pie</h3>
                          <p>Colócate junto a una pared, descalzo, con los talones junto a
                            la pared.<br> Coloca un libro u otro objeto pesado contra el
                            dedo más largo del pie. Mide la distancia entre el libro
                            (u otro objeto) y la pared.</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container guia-de-tallas">
      <div class="row content">
        <div class="col-md-3 sidenav">
          <!-- <p>Selecciona tipo o deporte</p> -->
          <div id="select-guia-tallas" class="cube-component cube-dropdown dropdown-lg">
            <div class="action">
              <div class="dropdown">
                <button type="button" id="dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  class="btn btn-default dropdown-toggle">
                  Selecciona un tipo o deporte
                </button>
                <ul class="dropdown-menu">
                  <li class="h3 separator">TIPO</li>
                  <!-- <li>HOMBRE</li>
                                  <li>MUJER</li> -->
                  <li class="active">
                    <a onclick="handleEventAnalytics('guia-de-tallas','tipo', 'junior')" id="cat-junior"
                      href="#guia-junior" data-category="NIÑOS">
                      NIÑOS
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','tipo', 'hombre')" id="cat-hombre"
                      href="#guia-hombre" data-category="HOMBRE">
                      HOMBRE
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','tipo', 'mujer')" id="cat-mujer" href="#guia-mujer"
                      data-category="MUJER">
                      MUJER
                    </a>
                  </li>
                  <li class="h3 separator">DEPORTES</li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'ciclismo')" id="cat-ciclismo"
                      href="#guia-ciclismo" data-category="CICLISMO">
                      CICLISMO
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'roller')" id="cat-roller"
                      href="#guia-roller" data-category="PATINAJE">
                      ROLLER
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'buceo')" id="cat-buceo"
                      href="#guia-buceo" data-category="BUCEO">
                      BUCEO
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'precision')" id="cat-precision"
                      href="#guia-precision" data-category="PRECISION">
                      DEPORTES PRECISIÓN
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'agua')" id="cat-agua" href="#guia-agua"
                      data-category="AGUA">
                      DEPORTES AGUA
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'naturaleza')"
                      id="cat-deportes-naturaleza" href="#guia-deportes-naturaleza" data-category="NATURALEZA">
                      DEPORTES NATURALEZA
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'montana')" id="cat-deportes-montana"
                      href="#guia-deportes-montana" data-category="SENDERISMO">
                      DEPORTES MONTAÑA
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'colectivos')"
                      id="cat-deportes-colectivos" href="#guia-deportes-colectivos" data-category="COLECTIVOS">
                      DEPORTES COLECTIVOS
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'fitness')"
                      id="cat-fitness-baile-combate" href="#guia-fitness-baile-combate-esgrima" data-category="FITNESS">
                      FITNESS, BAILE, COMBATE, ESGRIMA
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'equitacion')" id="cat-equitacion"
                      href="#guia-equitacion" data-category="EQUITACION">
                      EQUITACIÓN
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'triatlon')" id="cat-triatlon"
                      href="#guia-triatlon" data-category="TRIATLON">
                      TRIATLÓN
                    </a>
                  </li>
                  <li>
                    <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'hockey')" id="cat-hockey"
                      href="#guia-hockey" data-category="HOCKEY">
                      HOCKEY
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
  
          <ul class="nav nav-pills nav-stacked">
            <li class="h3">TIPO</li>
            <!-- <li>HOMBRE</li>
                      <li>MUJER</li> -->
            <li class="active">
              <a onclick="handleEventAnalytics('guia-de-tallas','tipo', 'junior')" id="cat-junior" href="#guia-junior"
                data-category="NIÑOS">
                NIÑOS
                <span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','tipo', 'hombre')" id="cat-hombre" href="#guia-hombre"
                data-category="HOMBRE">
                HOMBRE
                <span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','tipo', 'mujer')" id="cat-mujer" href="#guia-mujer"
                data-category="MUJER">
                MUJER
                <span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li class="h3">DEPORTES</li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'ciclismo')" id="cat-ciclismo"
                href="#guia-ciclismo" data-category="CICLISMO">
                CICLISMO<span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'roller')" id="cat-roller" href="#guia-roller"
                data-category="PATINAJE">
                ROLLER<span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'buceo')" id="cat-buceo" href="#guia-buceo"
                data-category="BUCEO">
                BUCEO<span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'precision')" id="cat-precision"
                href="#guia-precision" data-category="PRECISION">
                DEPORTES PRECISIÓN<span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'agua')" id="cat-agua" href="#guia-agua"
                data-category="AGUA">
                DEPORTES AGUA<span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'naturaleza')" id="cat-deportes-naturaleza"
                href="#guia-deportes-naturaleza" data-category="NATURALEZA">
                DEPORTES NATURALEZA<span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'montana')" id="cat-deportes-montana"
                href="#guia-deportes-montana" data-category="SENDERISMO">
                DEPORTES MONTAÑA<span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'colectivos')" id="cat-deportes-colectivos"
                href="#guia-deportes-colectivos" data-category="COLECTIVOS">
                DEPORTES COLECTIVOS<span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'fitness')" id="cat-fitness-baile-combate"
                href="#guia-fitness-baile-combate-esgrima" data-category="FITNESS">
                FITNESS, BAILE, COMBATE, ESGRIMA <span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'equitacion')" id="cat-equitacion"
                href="#guia-equitacion" data-category="EQUITACION">
                EQUITACIÓN <span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'triatlon')" id="cat-triatlon"
                href="#guia-triatlon" data-category="TRIATLON">
                TRIATLÓN <span class="icon-arrow2-r"></span>
              </a>
            </li>
            <li>
              <a onclick="handleEventAnalytics('guia-de-tallas','deporte', 'hockey')" id="cat-hockey"
                href="#guia-HOCKEY" data-category="HOCKEY">
                HOCKEY <span class="icon-arrow2-r"></span>
              </a>
            </li>
          </ul>
        </div>
  
        <div class="col-md-9">
          <div class="row">
            <!-- JUNIOR TEXTIL -->
            <div class="col-xs-12 wrapper-junior">
              <h3 id="guia-junior">Guía de tallas para Niños</h3>
              <!-- <p>Filtros</p> -->
              <div class="btn-group" role="group">
                <button id="btn-partes-arriba-junior" type="button" class="btn btn-default">
                  Partes de arriba
                </button>
                <button id="btn-partes-abajo-junior" type="button" class="btn btn-default">
                  Partes de abajo
                </button>
                <button id="btn-calzado-junior" type="button" class="btn btn-default">
                  Calzado
                </button>
                <button id="btn-accesorios-junior" type="button" class="btn btn-default">
                  Accesorios
                </button>
              </div>
              <!-- Camisetas... -->
  
              <div id="tabla-camisetas-junior" class="wrapper-table table-responsive">
                <h3>Camisetas, sudaderas, chaquetas, polares, pantalones, etc</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Altura(cm)</th>
                      <th>56-63</th>
                      <th>64-70</th>
                      <th>71-76</th>
                      <th>77-82</th>
                      <th>83-89</th>
                      <th>90-97</th>
                      <th>98-104</th>
                      <th>105-114</th>
                      <th>115-124</th>
                      <th>125-132</th>
                      <th>133-142</th>
                      <th>143-152</th>
                      <th>153-162</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="special">
                      <td class="special">Tallas universales</td>
                      <td>3 Meses</td>
                      <td>6 a 9 Meses</td>
                      <td>9 a 12 Meses</td>
                      <td>18 Meses</td>
                      <td>2 Años</td>
                      <td>3 Años</td>
                      <td>4 Años</td>
                      <td>5 Años</td>
                      <td>6 Años</td>
                      <td>8 Años</td>
                      <td>10 Años</td>
                      <td>12 Años</td>
                      <td>14 Años</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes -->
              <div id="tabla-guantes-junior" class="wrapper-table table-responsive" data-product="guantes">
                <h3>Guantes</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(cm)</th>
                      <th>13.9-14.9</th>
                      <th>14.91-15.9</th>
                      <th>15.91-16.9</th>
                      <th>16.91-17.8</th>
                      <th>17.81-18.6</th>
                      <th>18.61-19.45</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas universales</td>
                      <td>4 Años</td>
                      <td>6 Años</td>
                      <td>8 Años</td>
                      <td>10 Años</td>
                      <td>12 Años</td>
                      <td>14 Años</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Gorros -->
              <div id="tabla-gorros-junior" class="wrapper-table table-responsive">
                <h3>Gorros/as</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cabeza(cm)</th>
                      <th>41.1</th>
                      <th>43.6</th>
                      <th>44.9</th>
                      <th>45.7</th>
                      <th>47.4</th>
                      <th>48.6</th>
                      <th>49.7</th>
                      <th>50.6</th>
                    </tr>
                    <tr>
                      <th>Perímetro cabeza(cm)</th>
                      <th>51.1</th>
                      <th>52</th>
                      <th>52.9</th>
                      <th>53.8</th>
                      <th>54.7</th>
                      <th>55.6</th>
                      <th>56.5</th>
                      <th>57.4</th>
                      <th>58.3</th>
                      <th>59.2</th>
                      <th>60.1</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>3 Meses</td>
                      <td>6 Meses</td>
                      <td>9 Meses</td>
                      <td>12 Meses</td>
                      <td>18 Meses</td>
                      <td>2 Años</td>
                      <td>3 Años</td>
                      <td>4 Años</td>
                    </tr>
                    <tr>
                      <td>Tallas</td>
                      <td>T0</td>
                      <td>T1</td>
                      <td>T2</td>
                      <td>T3</td>
                      <td>T4</td>
                      <td>T5</td>
                      <td>T6</td>
                      <td>T7</td>
                      <td>T8</td>
                      <td>T9</td>
                      <td>T10</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Calzado 4-16anos -->
              <div id="tabla-calzado4-16-junior" class="wrapper-table table-responsive">
                <h3>Calzado 4-16 años</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>17.6 - 18.2</th>
                      <th>18.9 - 19.1</th>
                      <th>18.3 - 18.8</th>
                      <th>18.9 - 19.5</th>
                      <th>19.9 - 20.1</th>
                      <th>19.6 - 20.2</th>
                      <th>20.4 - 20.6</th>
                      <th>20.3 - 20.8</th>
                      <th>20.9 - 21.5</th>
                      <th>21.4 - 21.6</th>
                      <th>21.6 - 22.2</th>
                      <th>22.3 - 22.8</th>
                      <th>22.9 - 23.1</th>
                      <th>22.9 - 23.5</th>
                      <th>23.4 - 23.6</th>
                      <th>23.6 - 24.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>29</td>
                      <td>29½</td>
                      <td>30</td>
                      <td>31</td>
                      <td>31½</td>
                      <td>32</td>
                      <td>32½</td>
                      <td>33</td>
                      <td>34</td>
                      <td>34½</td>
                      <td>35</td>
                      <td>36</td>
                      <td>36½</td>
                      <td>37</td>
                      <td>37½</td>
                      <td>38</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>1</td>
                      <td>1.5</td>
                      <td>2</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>3.5</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5</td>
                      <td>5.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>10.5</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>1</td>
                      <td>1.5</td>
                      <td>2</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>3.5</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Calzado 0-4anos -->
              <div id="tabla-calzado0-4-junior" class="wrapper-table table-responsive">
                <h3>Calzado 0-4 años</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>10.9 - 11.5</th>
                      <th>11.6 - 12.2</th>
                      <th>12.4 - 12.6</th>
                      <th>12.3 - 12.8</th>
                      <th>13.4 - 13.6</th>
                      <th>12.9 - 13.5</th>
                      <th>13.6 - 14.2</th>
                      <th>14.9 - 15.1</th>
                      <th>14.3 - 14.8</th>
                      <th>14.9 - 15.5</th>
                      <th>15.9 - 16.1</th>
                      <th>15.6 - 16.2</th>
                      <th>16.3 - 16.8</th>
                      <th>17.4 - 17.6</th>
                      <th>16.9 - 17.5</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU :</td>
                      <td>19</td>
                      <td>20</td>
                      <td>20½</td>
                      <td>21</td>
                      <td>21½</td>
                      <td>22</td>
                      <td>23</td>
                      <td>23½</td>
                      <td>24</td>
                      <td>25</td>
                      <td>25½</td>
                      <td>26</td>
                      <td>27</td>
                      <td>27½</td>
                      <td>28</td>
                    </tr>
                    <tr>
                      <td>Tallas US :</td>
                      <td>3.5</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5</td>
                      <td>5.5</td>
                      <td>6</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>7.5</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9</td>
                      <td>9.5</td>
                      <td>10</td>
                      <td>10.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK :</td>
                      <td>3</td>
                      <td>3.5</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5</td>
                      <td>5.5</td>
                      <td>6</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>7.5</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9</td>
                      <td>9.5</td>
                      <td>10</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN JUNIOR -->
            </div>
  
            <!-- MUJER TEXTIL -->
            <div class="col-xs-12 wrapper-mujer">
              <h3 id="guia-mujer">Guía de tallas para Mujer</h3>
              <!-- <p>Filtros</p> -->
              <div class="btn-group" role="group">
                <button id="btn-partes-arriba-mujer" type="button" class="btn btn-default">Partes de arriba</button>
                <button id="btn-partes-abajo-mujer" type="button" class="btn btn-default">Partes de abajo</button>
                <button id="btn-calzado-mujer" type="button" class="btn btn-default">Calzado</button>
                <button id="btn-accesorios-mujer" type="button" class="btn btn-default">Accesorios</button>
              </div>
              <!-- Camisetas... -->
              <div id="tabla-camisetas-mujer" class="wrapper-table table-responsive">
                <h3>Camisetas, sudaderas, chaquetas, polares, camisas, bañadores, etc</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro pecho(cm)</th>
                      <th>80-83</th>
                      <th>84-87</th>
                      <th>88-91</th>
                      <th>92-95</th>
                      <th>96-99</th>
                      <th>100-103</th>
                      <th>104-107</th>
                      <th>108-113</th>
                      <th>114-118</th>
                      <th>119-123</th>
                      <th>124-129</th>
                      <th>130-135</th>
                      <th>136-141</th>
                      <th>142-146</th>
                      <th>147-153</th>
                      <th>154-159</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="">Tallas EU</td>
                      <td>34</td>
                      <td>36</td>
                      <td>38</td>
                      <td>40</td>
                      <td>42</td>
                      <td>44</td>
                      <td>46</td>
                      <td>48</td>
                      <td>50</td>
                      <td>52</td>
                      <td>54</td>
                      <td>56</td>
                      <td>58</td>
                      <td>60</td>
                      <td>62</td>
                      <td>64</td>
                    </tr>
                    <tr>
                      <td class="">Tallas universales</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M-L</td>
                      <td>L</td>
                      <td>L-XL</td>
                      <td>XL</td>
                      <td>XL-2XL</td>
                      <td>2XL</td>
                      <td>2XL-3XL</td>
                      <td>3XL</td>
                      <td>3XL-4XL</td>
                      <td>4XL</td>
                      <td>4XL-5XL</td>
                      <td>5XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Sujetadores -->
              <div id="tabla-sujetadores-mujer" class="wrapper-table table-responsive">
                <h3>Sujetadores</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr style="height: 55px;">
                      <th>Perímetro debajo de pecho(cm)</th>
                      <th>63-67</th>
                      <th>68-72</th>
                      <th>73-77</th>
                      <th>78-82</th>
                      <th>83-87</th>
                      <th>88-92</th>
                      <th>93-97</th>
                      <th>98-102</th>
                      <th>103-107</th>
                      <th>108-112</th>
                      <th>113-117</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas universales</td>
                      <td>80</td>
                      <td>85</td>
                      <td>90</td>
                      <td>95</td>
                      <td>100</td>
                      <td>105</td>
                      <td>110</td>
                      <td>115</td>
                      <td>120</td>
                      <td>125</td>
                      <td>130</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="tabla-bikinis-tops" class="wrapper-table table-responsive">
                <h3>Bikinis y Tops</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr style="height: 55px;">
                      <th colspan="9">Perímetro debajo de pecho(cm)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Copa AA</td>
                      <td>72-74</td>
                      <td>77-79</td>
                      <td>82-84</td>
                      <td>87-89</td>
                      <td>92-94</td>
                      <td>97-99</td>
                      <td>102-104</td>
                      <td>107-109</td>
                    </tr>
                    <tr>
                      <td>Copa A</td>
                      <td>75-77</td>
                      <td>80-82</td>
                      <td>85-87</td>
                      <td>90-92</td>
                      <td>95-97</td>
                      <td>100-102</td>
                      <td>105-107</td>
                      <td>110-112</td>
                    </tr>
                    <tr>
                      <td>Copa B</td>
                      <td>78-80</td>
                      <td>83-85</td>
                      <td>88-90</td>
                      <td>93-95</td>
                      <td>98-100</td>
                      <td>103-105</td>
                      <td>108-110</td>
                      <td>113-115</td>
                    </tr>
                    <tr>
                      <td>Copa C</td>
                      <td>81-83</td>
                      <td>86-88</td>
                      <td>91-93</td>
                      <td>96-98</td>
                      <td>101-103</td>
                      <td>106-108</td>
                      <td>111-113</td>
                      <td>116-118</td>
                    </tr>
                    <tr>
                      <td>Copa D</td>
                      <td>84-86</td>
                      <td>89-91</td>
                      <td>94-96</td>
                      <td>99-101</td>
                      <td>104-106</td>
                      <td>109-111</td>
                      <td>114-116</td>
                      <td>119-121</td>
                    </tr>
                    <tr>
                      <td>Copa E</td>
                      <td>87-89</td>
                      <td>92-94</td>
                      <td>97-99</td>
                      <td>102-104</td>
                      <td>107-109</td>
                      <td>112-114</td>
                      <td>117-119</td>
                      <td>122-124</td>
                    </tr>
                    <tr>
                      <td>Copa F</td>
                      <td>90-92</td>
                      <td>95-97</td>
                      <td>100-102</td>
                      <td>105-107</td>
                      <td>111-113</td>
                      <td>115-117</td>
                      <td>120-122</td>
                      <td>125-127</td>
                    </tr>
                    <tr>
                      <td>Copa G</td>
                      <td>93-95</td>
                      <td>98-100</td>
                      <td>103-105</td>
                      <td>108-110</td>
                      <td>113-115</td>
                      <td>118-120</td>
                      <td>123-125</td>
                      <td>128-130</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Partes de abajo ... -->
              <div id="tabla-partes-abajo-mujer" class="wrapper-table table-responsive">
                <h3>Shorts, pantalones, braguitas, etc</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cintura(cm)</th>
                      <th>58-62</th>
                      <th>63-65</th>
                      <th>66-69</th>
                      <th>70-73</th>
                      <th>74-77</th>
                      <th>78-84</th>
                      <th>85-90</th>
                      <th>91-96</th>
                      <th>97-102</th>
                      <th>103-108</th>
                      <th>109-114</th>
                      <th>115-120</th>
                      <th>121-128</th>
                      <th>129-132</th>
                      <th>133-139</th>
                      <th>140-145</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="">Tallas EU</td>
                      <td>34</td>
                      <td>36</td>
                      <td>38</td>
                      <td>40</td>
                      <td>42</td>
                      <td>44</td>
                      <td>46</td>
                      <td>48</td>
                      <td>50</td>
                      <td>52</td>
                      <td>54</td>
                      <td>56</td>
                      <td>58</td>
                      <td>60</td>
                      <td>62</td>
                      <td>64</td>
                    </tr>
                    <tr>
                      <td class="">Tallas universales</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M-L</td>
                      <td>L</td>
                      <td>L-XL</td>
                      <td>XL</td>
                      <td>XL-2XL</td>
                      <td>2XL</td>
                      <td>2XL-3XL</td>
                      <td>3XL</td>
                      <td>3XL-4XL</td>
                      <td>4XL</td>
                      <td>4XL-5XL</td>
                      <td>5XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Partes de abajo BAÑADORES ... -->
              <div id="tabla-partes-abajo-banador-mujer" class="wrapper-table table-responsive">
                <h3>Bañadores</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cintura(cm)</th>
                      <th>56-59</th>
                      <th>60-63</th>
                      <th>64-67</th>
                      <th>68-71</th>
                      <th>72-75</th>
                      <th>76-79</th>
                      <th>80-93</th>
                      <th>84-89</th>
                      <th>90-95</th>
                      <th>96-101</th>
                      <th>102-107</th>
                      <th>108-113</th>
                      <th>114-119</th>
                      <th>120-125</th>
                      <th>126-131</th>
                      <th>132-137</th>
                    </tr>
                    <tr>
                      <th>Perímetro cadera(cm)</th>
                      <th>86-89</th>
                      <th>90-93</th>
                      <th>94-97</th>
                      <th>98-101</th>
                      <th>102-105</th>
                      <th>106-109</th>
                      <th>110-113</th>
                      <th>114-119</th>
                      <th>120-125</th>
                      <th>126-131</th>
                      <th>132-137</th>
                      <th>138-143</th>
                      <th>144-149</th>
                      <th>150-155</th>
                      <th>156-161</th>
                      <th>162-167</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="">Tallas EU</td>
                      <td>34</td>
                      <td>36</td>
                      <td>38</td>
                      <td>40</td>
                      <td>42</td>
                      <td>44</td>
                      <td>46</td>
                      <td>48</td>
                      <td>50</td>
                      <td>52</td>
                      <td>54</td>
                      <td>56</td>
                      <td>58</td>
                      <td>60</td>
                      <td>62</td>
                      <td>64</td>
                    </tr>
                    <tr>
                      <td class="">Tallas universales</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M-L</td>
                      <td>L</td>
                      <td>L-XL</td>
                      <td>XL</td>
                      <td>XL-2XL</td>
                      <td>2XL</td>
                      <td>2XL-3XL</td>
                      <td>3XL</td>
                      <td>3XL-4XL</td>
                      <td>4XL</td>
                      <td>4XL-5XL</td>
                      <td>5XL</td>
                    </tr>
                    <tr>
                      <td class="">Talla Speedo</td>
                      <td>-</td>
                      <td>60</td>
                      <td>64</td>
                      <td>69</td>
                      <td>74</td>
                      <td>79</td>
                      <td>84</td>
                      <td>89</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="">Talla Arena</td>
                      <td>-</td>
                      <td>63</td>
                      <td>65</td>
                      <td>70</td>
                      <td>75</td>
                      <td>80</td>
                      <td>85</td>
                      <td>90</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes -->
              <div id="tabla-guantes-mujer" class="wrapper-table table-responsive">
                <h3>Guantes</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(cm)</th>
                      <th>16.25-17.1</th>
                      <th>17.11-17.95</th>
                      <th>17.96-18.8</th>
                      <th>18.81-19.5</th>
                      <th>19.51-20.1</th>
                      <th>20.11-20.7</th>
                      <th>20.71-21.3</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas universales</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>2XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Gorros -->
              <div id="tabla-gorros-mujer" class="wrapper-table table-responsive">
                <h3>Gorros</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cabeza(cm)</th>
                      <th>51.1</th>
                      <th>52</th>
                      <th>52.9</th>
                      <th>53.8</th>
                      <th>54.7</th>
                      <th>55.6</th>
                      <th>56.5</th>
                      <th>57.4</th>
                      <th>58.3</th>
                      <th>59.2</th>
                      <th>60.1</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>T0</td>
                      <td>T1</td>
                      <td>T2</td>
                      <td>T3</td>
                      <td>T4</td>
                      <td>T5</td>
                      <td>T6</td>
                      <td>T7</td>
                      <td>T8</td>
                      <td>T9</td>
                      <td>T10</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Calzado Mujer -->
              <div id="tabla-calzado-mujer" class="wrapper-table table-responsive">
                <h3>Calzado</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>20.9 - 21.5</th>
                      <th>21.6 - 22.2</th>
                      <th>22.3 - 22.8</th>
                      <th>22.9 - 23.5</th>
                      <th>23.6 - 24.2</th>
                      <th>24.3 - 24.9</th>
                      <th>25 - 25.6</th>
                      <th>25.7 - 26.2</th>
                      <th>26.3 - 26.8</th>
                      <th>26.9 - 27.5</th>
                      <th>27.6 - 28.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>34</td>
                      <td>35</td>
                      <td>36</td>
                      <td>37</td>
                      <td>38</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                      <td>43</td>
                      <td>44</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>3</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                      <td>10</td>
                      <td>11</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>1.5</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>4</td>
                      <td>5</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Calzado: ½ tallas disponibles para algunos productos -->
              <div id="tabla-calzado-algunos-mujer" class="wrapper-table table-responsive">
                <h3>Calzado: ½ tallas disponibles para algunos productos</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>21.4 - 21.6</th>
                      <th>22.9 - 23.1</th>
                      <th>23.4 - 23.6</th>
                      <th>24.9 - 25.1</th>
                      <th>26.4 - 26.6</th>
                      <th>27.4 - 27.6</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU :</td>
                      <td>34½</td>
                      <td>36½</td>
                      <td>37½</td>
                      <td>39½</td>
                      <td>41½</td>
                      <td>43½</td>
                    </tr>
                    <tr>
                      <td>Tallas US :</td>
                      <td>3.5</td>
                      <td>5</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                      <td>10.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK :</td>
                      <td>2</td>
                      <td>3.5</td>
                      <td>4.5</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN MUJER -->
            </div>
  
            <!-- HOMBRE TEXTIL -->
            <div class="col-xs-12 wrapper-hombre">
              <h3 id="guia-hombre">Guía de tallas para Hombre</h3>
              <!-- <p>Filtros</p> -->
              <div class="btn-group" role="group">
                <button id="btn-partes-arriba-hombre" type="button" class="btn btn-default">Partes de
                  arriba</button>
                <button id="btn-partes-abajo-hombre" type="button" class="btn btn-default">Partes de abajo</button>
                <button id="btn-calzado-hombre" type="button" class="btn btn-default">Calzado</button>
                <button id="btn-accesorios-hombre" type="button" class="btn btn-default">Accesorios</button>
              </div>
              <!-- Camisetas... -->
              <div id="tabla-camisetas-hombre" class="wrapper-table table-responsive">
                <h3>Camisetas, sudaderas, chaquetas, polares, camisas, etc</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro pecho(cm)</th>
                      <th>84-87</th>
                      <th>88-91</th>
                      <th>92-95</th>
                      <th>96-99</th>
                      <th>100-103</th>
                      <th>104-107</th>
                      <th>108-113</th>
                      <th>114-118</th>
                      <th>119-123</th>
                      <th>124-129</th>
                      <th>130-135</th>
                      <th>136-141</th>
                      <th>142-146</th>
                      <th>147-153</th>
                      <th>154-159</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="">Tallas EU</td>
                      <td>36</td>
                      <td>38</td>
                      <td>40</td>
                      <td>42</td>
                      <td>44</td>
                      <td>46</td>
                      <td>48</td>
                      <td>50</td>
                      <td>52</td>
                      <td>54</td>
                      <td>56</td>
                      <td>58</td>
                      <td>60</td>
                      <td>62</td>
                      <td>64</td>
                    </tr>
                    <tr>
                      <td class="">Tallas universales</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M-L</td>
                      <td>L</td>
                      <td>L-XL</td>
                      <td>XL</td>
                      <td>XL-2XL</td>
                      <td>2XL</td>
                      <td>2XL-3XL</td>
                      <td>3XL</td>
                      <td>3XL-4XL</td>
                      <td>4XL</td>
                      <td>4XL-5XL</td>
                      <td>5XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Partes de abajo ... -->
              <div id="tabla-partes-abajo-hombre" class="wrapper-table table-responsive">
                <h3>Shorts, pantalones, bañadores, etc</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cintura(cm)</th>
                      <th>70-73</th>
                      <th>74-77</th>
                      <th>78-81</th>
                      <th>82-85</th>
                      <th>86-89</th>
                      <th>90-95</th>
                      <th>96-100</th>
                      <th>101-105</th>
                      <th>106-111</th>
                      <th>112-117</th>
                      <th>118-123</th>
                      <th>124-129</th>
                      <th>130-135</th>
                      <th>136-141</th>
                      <th>142-147</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="">Tallas EU</td>
                      <td>36</td>
                      <td>38</td>
                      <td>40</td>
                      <td>42</td>
                      <td>44</td>
                      <td>46</td>
                      <td>48</td>
                      <td>50</td>
                      <td>52</td>
                      <td>54</td>
                      <td>56</td>
                      <td>58</td>
                      <td>60</td>
                      <td>62</td>
                      <td>64</td>
                    </tr>
                    <tr>
                      <td class="">Tallas universales</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M-L</td>
                      <td>L</td>
                      <td>L-XL</td>
                      <td>XL</td>
                      <td>XL-2XL</td>
                      <td>2XL</td>
                      <td>2XL-3XL</td>
                      <td>3XL</td>
                      <td>3XL-4XL</td>
                      <td>4XL</td>
                      <td>4XL-5XL</td>
                      <td>5XL</td>
                    </tr>
                    <tr>
                      <td class="">Tallas Speedo/Arena</td>
                      <td>70</td>
                      <td>75</td>
                      <td>80</td>
                      <td>85</td>
                      <td>90</td>
                      <td>95</td>
                      <td>100</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="">Tallas Adidas</td>
                      <td>1</td>
                      <td>2</td>
                      <td>3</td>
                      <td>4</td>
                      <td>5</td>
                      <td>6</td>
                      <td>7</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes -->
              <div id="tabla-guantes-hombre" class="wrapper-table table-responsive">
                <h3>Guantes</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(cm)</th>
                      <th>20.25-20.85</th>
                      <th>20.86-21.5</th>
                      <th>21.51-22.15</th>
                      <th>22.16-22.8</th>
                      <th>22.81-23.45</th>
                      <th>23.46-24.1</th>
                      <th>24.11-24.75</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas universales</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>2XL</td>
                      <td>3XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  
              <!-- Gorros -->
              <div id="tabla-gorros-hombre" class="wrapper-table table-responsive">
                <h3>Gorras, gorros, cascos, etc</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cabeza(cm)</th>
                      <th>51.1</th>
                      <th>52</th>
                      <th>52.9</th>
                      <th>53.8</th>
                      <th>54.7</th>
                      <th>55.6</th>
                      <th>56.5</th>
                      <th>57.4</th>
                      <th>58.3</th>
                      <th>59.2</th>
                      <th>60.1</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>T0</td>
                      <td>T1</td>
                      <td>T2</td>
                      <td>T3</td>
                      <td>T4</td>
                      <td>T5</td>
                      <td>T6</td>
                      <td>T7</td>
                      <td>T8</td>
                      <td>T9</td>
                      <td>T10</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Calzado Hombre -->
              <div id="tabla-calzado-hombre" class="wrapper-table table-responsive">
                <h3>Calzado</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud pie(cm)</th>
                      <th>24.3 - 24.9</th>
                      <th>25 - 25.6</th>
                      <th>25.7 - 26.2</th>
                      <th>26.3 - 26.8</th>
                      <th>26.9 - 27.5</th>
                      <th>27.6 - 28.2</th>
                      <th>28.3 - 28.8</th>
                      <th>28.9 - 29.5</th>
                      <th>29.6 - 30.2</th>
                      <th>30.3 - 30.8</th>
                      <th>30.9 - 31.5</th>
                      <th>31.6 - 32.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                      <td>43</td>
                      <td>44</td>
                      <td>45</td>
                      <td>46</td>
                      <td>47</td>
                      <td>48</td>
                      <td>49</td>
                      <td>50</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>6</td>
                      <td>7</td>
                      <td>7.5</td>
                      <td>8.5</td>
                      <td>9</td>
                      <td>10</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>14</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                      <td>10.5</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- ½ tallas disponibles para algunos productos -->
              <div id="tabla-calzado-algunos-hombre" class="wrapper-table table-responsive">
                <h3>Calzado: ½ tallas disponibles para algunos productos</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud pie(cm)</th>
                      <th>24.9 - 25.1</th>
                      <th>26.4 - 26.6</th>
                      <th>27.4 - 27.6</th>
                      <th>28.4 - 28.6</th>
                      <th>30.4 - 30.6</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU :</td>
                      <td>39½</td>
                      <td>41½</td>
                      <td>43½</td>
                      <td>44½</td>
                      <td>47½</td>
                    </tr>
                    <tr>
                      <td>Tallas US :</td>
                      <td>6.5</td>
                      <td>8</td>
                      <td>9.5</td>
                      <td>10.5</td>
                      <td>12.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK :</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                      <td>10</td>
                      <td>12</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN HOMBRE -->
            </div>
            <!-- CICLISMO -->
            <div class="col-xs-12 wrapper-ciclismo">
              <h3 id="guia-ciclismo">Ciclismo</h3>
              <!-- Bici Junior -->
              <div id="tabla-bicicletas-junior" class="wrapper-table table-responsive">
                <h3>Bicicleta Niños</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu Altura(cm)</th>
                      <th>75 - 90</th>
                      <th>90 - 105</th>
                      <th>105 - 120</th>
                      <th>120 - 135</th>
                      <th>135 - 155</th>
                      <th>130 - 160</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas bici</td>
                      <td>Sin pedales</td>
                      <td>14"</td>
                      <td>16"</td>
                      <td>20"</td>
                      <td>24"</td>
                      <td>BMX</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Bici BTT -->
              <div id="tabla-bicicletas-montaña" class="wrapper-table table-responsive">
                <h3>Bicicleta de Montaña</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Modelo bici</th>
                      <th>Talla XS</th>
                      <th>Talla S</th>
                      <th>Talla M</th>
                      <th>Talla L</th>
                      <th>Talla XL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ST 50/100</td>
                      <td>140cm a 154cm</td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 200cm</td>
                    </tr>
                    <tr>
                      <td>ST 120</td>
                      <td></td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 200cm</td>
                    </tr>
                    <tr>
                      <td>ST 520/530/540/560</td>
                      <td></td>
                      <td>155cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 200cm</td>
                    </tr>
                    <tr class="special">
                      <td>ST 520/530/540/560 Mujer</td>
                      <td></td>
                      <td>155cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td></td>
                    </tr>
                    <tr class="special">
                      <td>ST 520 S/530 S/540 S/560 S</td>
                      <td></td>
                      <td>155cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 179cm</td>
                      <td>180cm a 200cm</td>
                    </tr>
                    <tr>
                      <td>ST 900/900 S</td>
                      <td></td>
                      <td>150cm a 164cm</td>
                      <td>164cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>ST 900 Mujer</td>
                      <td></td>
                      <td>150cm a 164cm</td>
                      <td>164cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>XC 50/100</td>
                      <td></td>
                      <td>155cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 179cm</td>
                      <td>180cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>XC 500</td>
                      <td></td>
                      <td>155cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 179cm</td>
                      <td>180cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>XC 900/940</td>
                      <td></td>
                      <td></td>
                      <td>160cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>XC 100 S</td>
                      <td></td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>XC 900 S</td>
                      <td></td>
                      <td>150cm a 164cm</td>
                      <td>164cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>AM 100 S/500 S</td>
                      <td></td>
                      <td>155cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>AM 100 HARTRAIL</td>
                      <td></td>
                      <td></td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 200cm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="tabla-bicicletas-montaña-electrica" class="wrapper-table table-responsive">
                <h3>Bicicleta Eléctrica MTB</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Modelo bici</th>
                      <th>Talla XS</th>
                      <th>Talla S</th>
                      <th>Talla M</th>
                      <th>Talla L</th>
                      <th>Talla XL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>E- ST 100 HOMBRE</td>
                      <td></td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 200cm</td>
                    </tr>
                    <tr>
                      <td>E- ST 100 MUJER</td>
                      <td></td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td></td>
                    </tr>
                    <tr class="special">
                      <td>E- ST 500/520 HOMBRE</td>
                      <td></td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>185cm a 200cm</td>
                    </tr>
                    <tr>
                      <td>E- ST 500/520 MUJER</td>
                      <td></td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>E-ST 900 Hombre</td>
                      <td></td>
                      <td>155cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>180cm a 200cm</td>
                    </tr>
                    <tr>
                      <td>E-ST 900 Mujer</td>
                      <td></td>
                      <td>155cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td></td>
                    </tr>
                    <tr class="special">
                      <td>Stilus All Mountain</td>
                      <td></td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 174cm</td>
                      <td>175cm a 184cm</td>
                      <td>180cm a 200cm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="tabla-bicicletas-electricas-ciudad" class="wrapper-table table-responsive">
                <h3>Bicicletas Eléctricas Ciudad</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Modelo bici</th>
                      <th>Única</th>
                      <th>Talla S/M</th>
                      <th>Talla L/XL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="special">
                      <td>Elops 500E Cuadro bajo</td>
                      <td>160cm a 180cm</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>E TILT 500</td>
                      <td>145cm a 185cm</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="special">
                      <td>Elops 900E/920E/940E Cuadro bajo</td>
                      <td></td>
                      <td>155cm a 175cm</td>
                      <td>175cm a 195cm</td>
                    </tr>
                    <tr class="special">
                      <td>Elops 900E/920E/940E Cuadro alto </td>
                      <td></td>
                      <td>155cm a 175cm</td>
                      <td>175cm a 195cm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
               <!-- Bicicletas eléctricas trekking  -->
              <div id="tabla-bicicletas-electricas-trekking" class="wrapper-table table-responsive">
                <h3>Bicicletas Eléctricas Trekking</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Modelo bici</th>
                      <th>S</th>
                      <th>M</th>
                      <th>L</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Original 900E</td>
                      <td></td>
                      <td>145cm a 174cm</td>
                      <td>175cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>Riverside 500E</td>
                      <td>150cm a 165cm</td>
                      <td>166cm a 182cm</td>
                      <td>183cm a 195cm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Bicicletas trekking ciudad -->
              <div id="tabla-bicicletas-trekking" class="wrapper-table table-responsive">
                <h3>Bicicleta trekking</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Modelo bici</th>
                      <th>Talla S</th>
                      <th>Talla M</th>
                      <th>Talla L</th>
                      <th>Talla XL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Riverside 100</td>
                      <td></td>
                      <td>165cm a 182cm</td>
                      <td>183cm a 200cm</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Riverside 120</td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 179cm</td>
                      <td>180cm a 200cm</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Riverside 500</td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 179cm</td>
                      <td>180cm a 200cm</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Riverside 900/920</td>
                      <td>150cm a 164cm</td>
                      <td>165cm a 179cm</td>
                      <td>180cm a 200cm</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Bicicletas urbanas clásicas -->
              <div id="tabla-bicicletas-ciudad" class="wrapper-table table-responsive">
                <h3>Bicicleta Urbanas Clásicas</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Modelo bici</th>
                      <th>Única</th>
                      <th>Talla S/M</th>
                      <th>Talla L/XL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="special">
                      <td>Elops 100/120 Cuadro bajo</td>
                      <td>155cm a 175cm</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="special">
                      <td>Elops 100/120 Cuadro alto</td>
                      <td>165cm a 185cm</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Elops 520 Cuadro bajo</td>
                      <td></td>
                      <td>155cm a 175cm</td>
                      <td>175cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>Elops 520 Cuadro alto </td>
                      <td></td>
                      <td>155cm a 175cm</td>
                      <td>175cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>Elops 900/920</td>
                      <td></td>
                      <td>155cm a 175cm</td>
                      <td>175cm a 195cm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Bicicletas urbanas Híbridas -->
              <div id="tabla-bicicletas-ciudad-hibridas" class="wrapper-table table-responsive">
                <h3>Bicicleta Urbanas Híbridas</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Modelo bici</th>
                      <th>S</th>
                      <th>M</th>
                      <th>L</th>
                      <th>XL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="special">
                      <td>Hoprider 100/500/900 Cuadro bajo</td>
                      <td></td>
                      <td>150cm a 160cm</td>
                      <td>160cm a 178cm</td>
                      <td>185cm a 195cm</td>
                    </tr>
                    <tr class="special">
                      <td>Hoprider 100/500/900 Cuadro alto</td>
                      <td></td>
                      <td>160cm a 170cm</td>
                      <td>170cm a 185cm</td>
                      <td>185cm a 195cm</td>
                    </tr>
                    <tr>
                      <td>Fixie 500</td>
                      <td>150cm a 160cm</td>
                      <td>160cm a 170cm</td>
                      <td>170cm a 185cm</td>
                      <td>185cm a 200cm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Bici Carretera -->
              <div id="tabla-bicicletas-carretera" class="wrapper-table table-responsive">
                <h3>Bicicleta de Carretera</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Modelo bici</th>
                      <th>Talla XXS</th>
                      <th>Talla XS</th>
                      <th>Talla S</th>
                      <th>Talla M</th>
                      <th>Talla L</th>
                      <th>Talla XL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>TRIBAN 100/520/540</td>
                      <td></td>
                      <td>155cm a 165cm</td>
                      <td>165cm a 173cm</td>
                      <td>173cm a 182cm</td>
                      <td>182cm a 190cm</td>
                      <td>190cm a 200cm</td>
                    </tr>
                    <tr class="special">
                        <td>TRIBAN RC 100/120/500/520</td>
                      <td></td>
                      <td>155cm a 165cm</td>
                      <td>165cm a 173cm</td>
                      <td>173cm a 182cm</td>
                      <td>182cm a 190cm</td>
                      <td>190cm a 200cm</td>
                    </tr>
                    <tr class="special">
                        <td>TRIBAN 100/520 FLAT BAR</td>
                      <td></td>
                      <td>155cm a 165cm</td>
                      <td>165cm a 173cm</td>
                      <td>173cm a 182cm</td>
                      <td>182cm a 190cm</td>
                      <td>190cm a 200cm</td>
                    </tr>
                    <tr class="special">
                        <td>TRIBAN WOMEN EASY/REGULAR</td>
                      <td></td>
                      <td>150cm a 162cm</td>
                      <td>162cm a 170cm</td>
                      <td>170cm a 177cm</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>TRIBAN 520 WOMEN</td>
                      <td></td>
                      <td>150cm a 162cm</td>
                      <td>162cm a 170cm</td>
                      <td>170cm a 177cm</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="special">
                      <td>BTWIN ULTRA 500/ 520 AF GF</td>
                      <td></td>
                      <td>155cm a 166cm</td>
                      <td>166cm a 173cm</td>
                      <td>173cm a 182cm</td>
                      <td>182cm a 186cm</td>
                      <td>186cm a 196cm</td>
                    </tr>
                    <tr class="special">
                        <td>BTWIN ULTRA 900/920 CF</td>
                      <td></td>
                      <td>155cm a 166cm</td>
                      <td>166cm a 173cm</td>
                      <td>173cm a 182cm</td>
                      <td>182cm a 186cm</td>
                      <td>186cm a 196cm</td>
                    </tr>
                    <tr class="special">
                        <td>VAN RYSEL RCR 900/920 AF</td>
                      <td></td>
                      <td>155cm a 166cm</td>
                      <td>166cm a 173cm</td>
                      <td>173cm a 182cm</td>
                      <td>182cm a 186cm</td>
                      <td>186cm a 200cm</td>
                    </tr>
                    <tr class="special">
                        <td>VAN RYSEL RCR 900/920/940 CF</td>
                      <td></td>
                      <td>155cm a 166cm</td>
                      <td>166cm a 173cm</td>
                      <td>173cm a 182cm</td>
                      <td>182cm a 186cm</td>
                      <td>186cm a 196cm</td>
                    </tr>
                    <tr class="special">
                        <td>VAN RYSEL WOMEN AF</td>
                      <td>150cm a 162cm</td>
                      <td>162cm a 170cm</td>
                      <td>172cm a 177cm</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="special">
                        <td>VAN RYSEL WOMEN CF</td>
                      <td>150cm a 162cm</td>
                      <td>162cm a 170cm</td>
                      <td>172cm a 177cm</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="tabla-bicicletas-plegables" class="wrapper-table table-responsive">
                <h3>Bicicleta Plegable</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Modelo bici</th>
                      <th>Única</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>TILT</td>
                      <td>145cm a 185cm</td>
                    </tr>
                    <tr>
                      <td>TILT 500</td>
                      <td>145cm a 185cm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Casco Bebe -->
              <div id="tabla-casco-bebe-junior-ciclismo" class="wrapper-table table-responsive">
                <h3>Cascos Bebe</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cabeza(cm)</th>
                      <th>41.1</th>
                      <th>43.6</th>
                      <th>44.9</th>
                      <th>45.7</th>
                      <th>47.4</th>
                      <th>48.6</th>
                      <th>49.7</th>
                      <th>50.6</th>
                      <th>52</th>
                      <th>53</th>
                      <th>54</th>
                      <th>55</th>
                      <th>56</th>
                      <th>57</th>
                      <th>58</th>
                      <th>59</th>
                      <th>60</th>
                      <th>61</th>
                      <th>62</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>3 Meses</td>
                      <td>6 Meses</td>
                      <td>9 Meses</td>
                      <td>12 Meses</td>
                      <td>18 Meses</td>
                      <td>2 Años</td>
                      <td>3 Años</td>
                      <td>4 Años</td>
                      <td>M</td>
                      <td>M</td>
                      <td>M</td>
                      <td>M</td>
                      <td>M</td>
                      <td>M-L</td>
                      <td>M-L</td>
                      <td>M-L</td>
                      <td>L</td>
                      <td>L</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Casco Junior Adulto -->
              <div id="tabla-casco-junior-ciclismo" class="wrapper-table table-responsive">
                <h3>Cascos Niños y Adulto</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cabeza(cm)</th>
                      <th>52</th>
                      <th>53</th>
                      <th>54</th>
                      <th>55</th>
                      <th>56</th>
                      <th>57</th>
                      <th>58</th>
                      <th>59</th>
                      <th>60</th>
                      <th>61</th>
                      <th>62</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>M</td>
                      <td>M</td>
                      <td>M</td>
                      <td>M</td>
                      <td>M</td>
                      <td>M-L</td>
                      <td>M-L</td>
                      <td>M-L</td>
                      <td>L</td>
                      <td>L</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Junior -->
              <div id="tabla-guantes-junior-ciclismo" class="wrapper-table table-responsive">
                <h3>Guantes Niños</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(cm)</th>
                      <th>13.9-14.9</th>
                      <th>14.91-15.9</th>
                      <th>15.91-16.9</th>
                      <th>16.91-17.8</th>
                      <th>17.81-18.6</th>
                      <th>18.61-19.45</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>4 Ans</td>
                      <td>6 Ans</td>
                      <td>8 Ans</td>
                      <td>10 Ans</td>
                      <td>12 Ans</td>
                      <td>14 Ans</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Mujer -->
              <div id="tabla-guantes-mujer-ciclismo" class="wrapper-table table-responsive">
                <h3>Guantes Mujer</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(cm)</th>
                      <th>16.25-17.1</th>
                      <th>17.11-17.95</th>
                      <th>17.96-18.8</th>
                      <th>18.81-19.5</th>
                      <th>19.51-20.1</th>
                      <th>20.11-20.7</th>
                      <th>20.71-21.3</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>2XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Hombre -->
              <div id="tabla-guantes-hombre-ciclismo" class="wrapper-table table-responsive">
                <h3>Guantes Hombre</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(cm)</th>
                      <th>20.25-20.85</th>
                      <th>20.86-21.5</th>
                      <th>21.51-22.15</th>
                      <th>22.16-22.8</th>
                      <th>22.81-23.45</th>
                      <th>23.46-24.1</th>
                      <th>24.11-24.75</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>2XL</td>
                      <td>3XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN CICLISMO -->
            </div>
  
            <!-- ROLLER -->
            <div class="col-xs-12 wrapper-roller">
              <h3 id="guia-roller">Roller Junior</h3>
              <!-- Roller 0-16anos -->
              <div id="tabla-junior-roller" class="wrapper-table table-responsive">
                <h3>Roller 0-16 años</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>17.6 - 18.2</th>
                      <th>18.9 - 19.1</th>
                      <th>18.3 - 18.8</th>
                      <th>18.9 - 19.5</th>
                      <th>19.9 - 20.1</th>
                      <th>19.6 - 20.2</th>
                      <th>20.4 - 20.6</th>
                      <th>20.3 - 20.8</th>
                      <th>20.9 - 21.5</th>
                      <th>21.4 - 21.6</th>
                      <th>21.6 - 22.2</th>
                      <th>22.3 - 22.8</th>
                      <th>22.9 - 23.1</th>
                      <th>22.9 - 23.5</th>
                      <th>23.4 - 23.6</th>
                      <th>23.6 - 24.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>29</td>
                      <td>29½</td>
                      <td>30</td>
                      <td>31</td>
                      <td>31½</td>
                      <td>32</td>
                      <td>32½</td>
                      <td>33</td>
                      <td>34</td>
                      <td>34½</td>
                      <td>35</td>
                      <td>36</td>
                      <td>36½</td>
                      <td>37</td>
                      <td>37½</td>
                      <td>38</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>1</td>
                      <td>1.5</td>
                      <td>2</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>3.5</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5</td>
                      <td>5.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>10.5</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>1</td>
                      <td>1.5</td>
                      <td>2</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>3.5</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Roller Mujer -->
              <div id="tabla-mujer-roller" class="wrapper-table table-responsive">
                <h3>Roller Mujer</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>20.9 - 21.5</th>
                      <th>21.6 - 22.2</th>
                      <th>22.3 - 22.8</th>
                      <th>22.9 - 23.5</th>
                      <th>23.6 - 24.2</th>
                      <th>24.3 - 24.9</th>
                      <th>25 - 25.6</th>
                      <th>25.7 - 26.2</th>
                      <th>26.3 - 26.8</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>34</td>
                      <td>35</td>
                      <td>36</td>
                      <td>37</td>
                      <td>38</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>3</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>1.5</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>4</td>
                      <td>5</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Roller Mujer: ½ tallas disponibles para algunos productos -->
              <div id="tabla-mujer-algunos-roller" class="wrapper-table table-responsive">
                <h3>tallas disponibles para algunos productos:</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>21.4 - 21.6</th>
                      <th>22.9 - 23.1</th>
                      <th>23.4 - 23.6</th>
                      <th>24.9 - 25.1</th>
                      <th>26.4 - 26.6</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU :</td>
                      <td>34½</td>
                      <td>36½</td>
                      <td>37½</td>
                      <td>39½</td>
                      <td>41½</td>
                    </tr>
                    <tr>
                      <td>Tallas US :</td>
                      <td>3.5</td>
                      <td>5</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                    </tr>
                    <tr>
                      <td>Tallas UK :</td>
                      <td>2</td>
                      <td>3.5</td>
                      <td>4.5</td>
                      <td>6</td>
                      <td>7.5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Roller Hombre -->
              <div id="tabla-hombre-roller" class="wrapper-table table-responsive">
                <h3>Roller Hombre</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>24.3 - 24.9</th>
                      <th>25 - 25.6</th>
                      <th>25.7 - 26.2</th>
                      <th>26.3 - 26.8</th>
                      <th>26.9 - 27.5</th>
                      <th>27.6 - 28.2</th>
                      <th>28.3 - 28.8</th>
                      <th>28.9 - 29.5</th>
                      <th>29.6 - 30.2</th>
                      <th>30.3 - 30.8</th>
                      <th>30.9 - 31.5</th>
                      <th>31.6 - 32.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                      <td>43</td>
                      <td>44</td>
                      <td>45</td>
                      <td>46</td>
                      <td>47</td>
                      <td>48</td>
                      <td>49</td>
                      <td>50</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>6</td>
                      <td>7</td>
                      <td>7.5</td>
                      <td>8.5</td>
                      <td>9</td>
                      <td>10</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>14</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                      <td>10.5</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Roller Hombre: ½ tallas disponibles para algunos productos -->
              <div id="tabla-hombre-algunos-roller" class="wrapper-table table-responsive">
                <h3>tallas disponibles para algunos productos:</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>24.9 - 25.1</th>
                      <th>26.4 - 26.6</th>
                      <th>27.4 - 27.6</th>
                      <th>28.4 - 28.6</th>
                      <th>30.4 - 30.6</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU :</td>
                      <td>39½</td>
                      <td>41½</td>
                      <td>43½</td>
                      <td>44½</td>
                      <td>47½</td>
                    </tr>
                    <tr>
                      <td>Tallas US :</td>
                      <td>6.5</td>
                      <td>8</td>
                      <td>9.5</td>
                      <td>10.5</td>
                      <td>12.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK :</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                      <td>10</td>
                      <td>12</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Casco  -->
              <div id="tabla-casco-roller" class="wrapper-table table-responsive">
                <h3>Casco Roller</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cabeza(cm)</th>
                      <th>47-52</th>
                      <th>52-55</th>
                      <th>55-59</th>
                      <th>59-62</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Protecciones Junior -->
              <div id="tabla-protecciones-junior-roller" class="wrapper-table table-responsive">
                <h3>Protecciones Niños Roller</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Contorno codo(cm)</th>
                      <th>15-19</th>
                      <th>17-21</th>
                      <th>20-25</th>
                    </tr>
                    <tr>
                      <th>Contorno muñeca(cm)</th>
                      <th>11-13</th>
                      <th>12-14</th>
                      <th>25-31</th>
                    </tr>
                    <tr>
                      <th>Contorno rodilla(cm)</th>
                      <th>21-27</th>
                      <th>13-15</th>
                      <th>29-34</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Protecciones Adulto  -->
              <div id="tabla-protecciones-adulto-roller" class="wrapper-table table-responsive">
                <h3>Protecciones Adulto Roller</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Altura(cm)</th>
                      <th>
                        < 150</th> <th>150-160
                      </th>
                      <th>160-170</th>
                      <th>170-180</th>
                      <th>180-190</th>
                      <th> > 190</th>
                    </tr>
                    <tr>
                      <th>Peso (kg)</th>
                      <th>50-60</th>
                      <th>60-70</th>
                      <th>70-80</th>
                      <th>80-90</th>
                      <th>90-100</th>
                      <th> > 100</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M</td>
                      <td>L</td>
                      <td>L-XL</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN JUNIOR -->
            </div>
            <!-- FIN JUNIOR -->
  
  
            <!-- BUCEO -->
            <div class="col-xs-12 wrapper-buceo">
              <h3 id="guia-buceo">Buceo</h3>
              <!-- Traje Shorty -->
              <div id="tabla-shorty-buceo" class="wrapper-table table-responsive">
                <h3>Traje / Shorty</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu altura(cm)</th>
                      <th>166 - 170</th>
                      <th>171 - 175</th>
                      <th>176 - 180</th>
                      <th>181 - 185</th>
                      <th>186 - 190</th>
                      <th>191 - 195</th>
                      <th>196 - 201</th>
                    </tr>
                    <tr class="special">
                      <th>Perímetro de pecho(cm)</th>
                      <th>84</th>
                      <th>92</th>
                      <th>100</th>
                      <th>108</th>
                      <th>116</th>
                      <th>124</th>
                      <th>132</th>
                    </tr>
                    <tr class="special">
                      <th>Perímetro de cintura(cm)</th>
                      <th>72</th>
                      <th>78</th>
                      <th>84</th>
                      <th>90</th>
                      <th>96</th>
                      <th>102</th>
                      <th>108</th>
                    </tr>
                    <tr class="special">
                      <th>Perímetro de cadera(cm)</th>
                      <th>84</th>
                      <th>90</th>
                      <th>96</th>
                      <th>102</th>
                      <th>108</th>
                      <th>114</th>
                      <th>120</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>36</td>
                      <td>38</td>
                      <td>40</td>
                      <td>42 / 44</td>
                      <td>46 / 48</td>
                      <td>50 / 52</td>
                      <td>54</td>
                    </tr>
                    <tr>
                      <td>Tallas universales:</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>2XL</td>
                      <td>3XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Traje Neopreno Hombre -->
              <div id="tabla-traje-hombre-buceo" class="wrapper-table table-responsive">
                <h3>Traje Neopreno Hombre</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Altura(cm)</th>
                      <th>168-170</th>
                      <th>171-173</th>
                      <th>174-176</th>
                      <th>177-179</th>
                      <th>180-182</th>
                      <th>183-184</th>
                      <th>185-186</th>
                    </tr>
                    <tr>
                      <th>pecho(cm)</th>
                      <th>84-87</th>
                      <th>88-91</th>
                      <th>92-95</th>
                      <th>96-103</th>
                      <th>104-113</th>
                      <th>114-123</th>
                      <th>124-135</th>
                    </tr>
                    <tr>
                      <th>cintura(cm)</th>
                      <th>70-73</th>
                      <th>74-77</th>
                      <th>78-83</th>
                      <th>84-89</th>
                      <th>90-100</th>
                      <th>101-111</th>
                      <th>112-123</th>
                    </tr>
                    <tr>
                      <th>cadera(cm)</th>
                      <th>80-85</th>
                      <th>86-91</th>
                      <th>92-97</th>
                      <th>98-103</th>
                      <th>104-112</th>
                      <th>113-122</th>
                      <th>123-132</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas neopreno</td>
                      <td>1</td>
                      <td>2</td>
                      <td>3</td>
                      <td>4</td>
                      <td>5</td>
                      <td>6</td>
                      <td>7</td>
                    </tr>
                    <tr>
                      <td>Tallas universales:</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>2XL</td>
                      <td>3XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Traje Neopreno Mujer -->
              <div id="tabla-traje-mujer-buceo" class="wrapper-table table-responsive">
                <h3>Traje Neopreno Mujer</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Altura(cm)</th>
                      <th>163</th>
                      <th>165</th>
                      <th>167</th>
                      <th>169</th>
                      <th>170</th>
                      <th>171</th>
                      <th>172</th>
                      <th>173</th>
                    </tr>
                    <tr>
                      <th>pecho(cm)</th>
                      <th>80-83</th>
                      <th>84-87</th>
                      <th>88-91</th>
                      <th>92-95</th>
                      <th>96-103</th>
                      <th>104-113</th>
                      <th>114-123</th>
                      <th>124-135</th>
                    </tr>
                    <tr>
                      <th>cintura(cm)</th>
                      <th>58-62</th>
                      <th>62-65</th>
                      <th>66-69</th>
                      <th>70-73</th>
                      <th>74-84</th>
                      <th>85-96</th>
                      <th>97-108</th>
                      <th>109-120</th>
                    </tr>
                    <tr>
                      <th>cadera(cm)</th>
                      <th>89-90</th>
                      <th>91-93</th>
                      <th>94-97</th>
                      <th>98-101</th>
                      <th>102-110</th>
                      <th>111-120</th>
                      <th>121-130</th>
                      <th>131-140</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas neopreno</td>
                      <td></td>
                      <td>1</td>
                      <td>2</td>
                      <td>3</td>
                      <td>4</td>
                      <td>5</td>
                      <td>6</td>
                      <td>7</td>
                    </tr>
                    <tr>
                      <td>Tallas universales:</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>2XL</td>
                      <td>3XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Traje Neopreno Niños -->
              <div id="tabla-traje-junior-buceo" class="wrapper-table table-responsive">
                <h3>Traje Neopreno Niños</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Altura(cm)</th>
                      <th>98-104</th>
                      <th>115-124</th>
                      <th>125-132</th>
                      <th>133-142</th>
                      <th>143-152</th>
                      <th>153-162</th>
                    </tr>
                    <tr>
                      <th>pecho(cm)</th>
                      <th>52-54</th>
                      <th>58-60</th>
                      <th>61-64</th>
                      <th>65-68</th>
                      <th>69-75</th>
                      <th>76-82</th>
                    </tr>
                    <tr>
                      <th>cintura(cm)</th>
                      <th>49-51</th>
                      <th>54-55</th>
                      <th>56-57</th>
                      <th>58-60</th>
                      <th>61-64</th>
                      <th>65-69</th>
                    </tr>
                    <tr>
                      <th>cadera(cm)</th>
                      <th>54-57</th>
                      <th>62-65</th>
                      <th>66-69</th>
                      <th>70-73</th>
                      <th>74-77</th>
                      <th>78-92</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas neopreno</td>
                      <td>4</td>
                      <td>6</td>
                      <td>8</td>
                      <td>10</td>
                      <td>12</td>
                      <td>14</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Aletas / Escarpines Hombre -->
              <div id="tabla-aletas-hombre-buceo" class="wrapper-table table-responsive">
                <h3>ALETAS / ESCARPINES DE BUCEO HOMBRE</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>24.3 - 24.9</th>
                      <th>25 - 25.6</th>
                      <th>25.7 - 26.2</th>
                      <th>26.3 - 26.8</th>
                      <th>26.9 - 27.5</th>
                      <th>27.6 - 28.2</th>
                      <th>28.3 - 28.8</th>
                      <th>28.9 - 29.5</th>
                      <th>29.6 - 30.2</th>
                      <th>30.3 - 30.8</th>
                      <th>30.9 - 31.5</th>
                      <th>31.6 - 32.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                      <td>43</td>
                      <td>44</td>
                      <td>45</td>
                      <td>46</td>
                      <td>47</td>
                      <td>48</td>
                      <td>49</td>
                      <td>50</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>6</td>
                      <td>7</td>
                      <td>7.5</td>
                      <td>8.5</td>
                      <td>9</td>
                      <td>10</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>14</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                      <td>10.5</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- ½ tallas disponibles para algunos productos -->
              <div id="tabla-aletas-medias-hombre-buceo" class="wrapper-table table-responsive">
                <h3>½ tallas disponibles para algunos productos</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>24.9 - 25.1</th>
                      <th>26.4 - 26.6</th>
                      <th>27.4 - 27.6</th>
                      <th>28.4 - 28.6</th>
                      <th>30.4 - 30.6</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU :</td>
                      <td>39½</td>
                      <td>41½</td>
                      <td>43½</td>
                      <td>44½</td>
                      <td>47½</td>
                    </tr>
                    <tr>
                      <td>Tallas US :</td>
                      <td>6.5</td>
                      <td>8</td>
                      <td>9.5</td>
                      <td>10.5</td>
                      <td>12.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK :</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                      <td>10</td>
                      <td>12</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Aletas / escarpines Mujer -->
              <div id="tabla-aletas-mujer-buceo" class="wrapper-table table-responsive">
                <h3>ALETAS / ESCARPINES DE BUCEO MUJER</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>20.9 - 21.5</th>
                      <th>21.6 - 22.2</th>
                      <th>22.3 - 22.8</th>
                      <th>22.9 - 23.5</th>
                      <th>23.6 - 24.2</th>
                      <th>24.3 - 24.9</th>
                      <th>25 - 25.6</th>
                      <th>25.7 - 26.2</th>
                      <th>26.3 - 26.8</th>
                      <th>26.9 - 27.5</th>
                      <th>27.6 - 28.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>34</td>
                      <td>35</td>
                      <td>36</td>
                      <td>37</td>
                      <td>38</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                      <td>43</td>
                      <td>44</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>3</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                      <td>10</td>
                      <td>11</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>1.5</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>4</td>
                      <td>5</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- ½ tallas disponibles para algunos productos -->
              <div id="tabla-aletas-medias-mujer-buceo" class="wrapper-table table-responsive">
                <h3>½ tallas disponibles para algunos productos</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>21.4 - 21.6</th>
                      <th>22.9 - 23.1</th>
                      <th>23.4 - 23.6</th>
                      <th>24.9 - 25.1</th>
                      <th>26.4 - 26.6</th>
                      <th>27.4 - 27.6</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU :</td>
                      <td>34½</td>
                      <td>36½</td>
                      <td>37½</td>
                      <td>39½</td>
                      <td>41½</td>
                      <td>43½</td>
                    </tr>
                    <tr>
                      <td>Tallas US :</td>
                      <td>3.5</td>
                      <td>5</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                      <td>10.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK :</td>
                      <td>2</td>
                      <td>3.5</td>
                      <td>4.5</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Aletas y escarpines Junior -->
              <div id="tabla-aletas-junior-buceo" class="wrapper-table table-responsive">
                <h3>Aletas y escarpines Niños</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>17.6 - 18.2</th>
                      <th>18.9 - 19.1</th>
                      <th>18.3 - 18.8</th>
                      <th>18.9 - 19.5</th>
                      <th>19.9 - 20.1</th>
                      <th>19.6 - 20.2</th>
                      <th>20.4 - 20.6</th>
                      <th>20.3 - 20.8</th>
                      <th>20.9 - 21.5</th>
                      <th>21.4 - 21.6</th>
                      <th>21.6 - 22.2</th>
                      <th>22.3 - 22.8</th>
                      <th>22.9 - 23.1</th>
                      <th>22.9 - 23.5</th>
                      <th>23.4 - 23.6</th>
                      <th>23.6 - 24.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>29</td>
                      <td>29½</td>
                      <td>30</td>
                      <td>31</td>
                      <td>31½</td>
                      <td>32</td>
                      <td>32½</td>
                      <td>33</td>
                      <td>34</td>
                      <td>34½</td>
                      <td>35</td>
                      <td>36</td>
                      <td>36½</td>
                      <td>37</td>
                      <td>37½</td>
                      <td>38</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>1</td>
                      <td>1.5</td>
                      <td>2</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>3.5</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5</td>
                      <td>5.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>10.5</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>1</td>
                      <td>1.5</td>
                      <td>2</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>3.5</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- ½ tallas disponibles para algunos productos -->
              <div id="tabla-aletas-medias-junior-buceo" class="wrapper-table table-responsive">
                <h3>½ tallas disponibles para algunos productos</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>18.9 - 19.1</th>
                      <th>19.9 - 20.1</th>
                      <th>20.4 - 20.6</th>
                      <th>21.4 - 21.6</th>
                      <th>22.9 - 23.1</th>
                      <th>23.4 - 23.6</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU :</td>
                      <td>29½</td>
                      <td>31½</td>
                      <td>32½</td>
                      <td>34½</td>
                      <td>36½</td>
                      <td>37½</td>
                    </tr>
                    <tr>
                      <td>Tallas US :</td>
                      <td>11.5</td>
                      <td>13</td>
                      <td>1</td>
                      <td>2.5</td>
                      <td>4</td>
                      <td>5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK :</td>
                      <td>11</td>
                      <td>12.5</td>
                      <td>13.5</td>
                      <td>2</td>
                      <td>3.5</td>
                      <td>4.5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Hombre -->
              <div id="tabla-guantes-hombre-buceo" class="wrapper-table table-responsive">
                <h3>Guantes Hombre</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(cm)</th>
                      <th>20.25-20.85</th>
                      <th>20.86-21.5</th>
                      <th>21.51-22.15</th>
                      <th>22.16-22.8</th>
                      <th>22.81-23.45</th>
                      <th>23.46-24.1</th>
                      <th>24.11-24.75</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>2XL</td>
                      <td>3XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Mujer -->
              <div id="tabla-guantes-mujer-buceo" class="wrapper-table table-responsive">
                <h3>Guantes Mujer</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(cm)</th>
                      <th>16.25-17.1</th>
                      <th>17.11-17.95</th>
                      <th>17.96-18.8</th>
                      <th>18.81-19.5</th>
                      <th>19.51-20.1</th>
                      <th>20.11-20.7</th>
                      <th>20.71-21.3</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>2XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Junior -->
              <div id="tabla-guantes-junior-buceo" class="wrapper-table table-responsive">
                <h3>Guantes Niños</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(cm)</th>
                      <th>13.9-14.9</th>
                      <th>14.91-15.9</th>
                      <th>15.91-16.9</th>
                      <th>16.91-17.8</th>
                      <th>17.81-18.6</th>
                      <th>18.61-19.45</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>4 Ans</td>
                      <td>6 Ans</td>
                      <td>8 Ans</td>
                      <td>10 Ans</td>
                      <td>12 Ans</td>
                      <td>14 Ans</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Capucha -->
              <div id="tabla-capucha-buceo" class="wrapper-table table-responsive">
                <h3>Capucha</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cabeza(cm)</th>
                      <th>53 - 56</th>
                      <th>57 - 60</th>
                      <th>60</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>XS / S</td>
                      <td>M / L</td>
                      <td>XL / 2XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN JUNIOR -->
            </div>
  
            <!-- DEPORTES PRECISION -->
            <div class="col-xs-12 wrapper-precision">
              <h3 id="guia-precision">Deportes de precisión</h3>
              <!-- Tiro con arco -->
              <div id="tabla-tiro-con-arco" class="wrapper-table table-responsive">
                <h3>Tiro con arco</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu altura(cm)</th>
                      <th>110 - 130</th>
                      <th>130 - 150</th>
                      <th>150 - 170</th>
                      <th>170 - 190</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas Universal:</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                    <tr>
                      <td>Talla:</td>
                      <td>58"</td>
                      <td>66"</td>
                      <td>68"</td>
                      <td>70"</td>
                    </tr>
                    <tr>
                      <td>Potencia:</td>
                      <td>15 libras</td>
                      <td>18 libras</td>
                      <td>20 libras</td>
                      <td>22 libras</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
  
            <!-- DEPORTES AGUA -->
            <div class="col-xs-12 wrapper-agua">
              <h3 id="guia-agua">Deportes de agua</h3>
              <!-- Bikinis Mujer -->
              <div id="tabla-bikinis-mujer-agua" class="wrapper-table table-responsive">
                <h3>Bikinis Mujer</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cintura(cm)</th>
                      <th>56-59</th>
                      <th>60-63</th>
                      <th>64-67</th>
                      <th>68-71</th>
                      <th>72-75</th>
                      <th>76-79</th>
                      <th>80-93</th>
                      <th>84-89</th>
                      <th>90-95</th>
                      <th>96-101</th>
                      <th>102-107</th>
                      <th>108-113</th>
                      <th>114-119</th>
                      <th>120-125</th>
                      <th>126-131</th>
                      <th>132-137</th>
                    </tr>
                    <tr>
                      <th>Perímetro cadera(cm)</th>
                      <th>86-89</th>
                      <th>90-93</th>
                      <th>94-97</th>
                      <th>98-101</th>
                      <th>102-105</th>
                      <th>106-109</th>
                      <th>110-113</th>
                      <th>114-119</th>
                      <th>120-125</th>
                      <th>126-131</th>
                      <th>132-137</th>
                      <th>138-143</th>
                      <th>144-149</th>
                      <th>150-155</th>
                      <th>156-161</th>
                      <th>162-167</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="">Tallas EU</td>
                      <td>34</td>
                      <td>36</td>
                      <td>38</td>
                      <td>40</td>
                      <td>42</td>
                      <td>44</td>
                      <td>46</td>
                      <td>48</td>
                      <td>50</td>
                      <td>52</td>
                      <td>54</td>
                      <td>56</td>
                      <td>58</td>
                      <td>60</td>
                      <td>62</td>
                      <td>64</td>
                    </tr>
                    <tr>
                      <td class="">Tallas universales</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M-L</td>
                      <td>L</td>
                      <td>L-XL</td>
                      <td>XL</td>
                      <td>XL-2XL</td>
                      <td>2XL</td>
                      <td>2XL-3XL</td>
                      <td>3XL</td>
                      <td>3XL-4XL</td>
                      <td>4XL</td>
                      <td>4XL-5XL</td>
                      <td>5XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Sujetadores -->
              <div id="tabla-sujetadores-mujer" class="wrapper-table table-responsive">
                <h3>Sujetadores</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr class="special">
                      <th>Perímetro debajo de pecho(cm)</th>
                      <th>63-67</th>
                      <th>68-72</th>
                      <th>73-77</th>
                      <th>78-82</th>
                      <th>83-87</th>
                      <th>88-92</th>
                      <th>93-97</th>
                      <th>98-102</th>
                      <th>103-107</th>
                      <th>108-112</th>
                      <th>113-117</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas universales</td>
                      <td>80</td>
                      <td>85</td>
                      <td>90</td>
                      <td>95</td>
                      <td>100</td>
                      <td>105</td>
                      <td>110</td>
                      <td>115</td>
                      <td>120</td>
                      <td>125</td>
                      <td>130</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="tabla-bikinis-tops" class="wrapper-table table-responsive">
                <h3>Bikinis y Tops</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr style="height: 55px;">
                      <th colspan="9">Perímetro debajo de pecho(cm)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Copa AA</td>
                      <td>72-74</td>
                      <td>77-79</td>
                      <td>82-84</td>
                      <td>87-89</td>
                      <td>92-94</td>
                      <td>97-99</td>
                      <td>102-104</td>
                      <td>107-109</td>
                    </tr>
                    <tr>
                      <td>Copa A</td>
                      <td>75-77</td>
                      <td>80-82</td>
                      <td>85-87</td>
                      <td>90-92</td>
                      <td>95-97</td>
                      <td>100-102</td>
                      <td>105-107</td>
                      <td>110-112</td>
                    </tr>
                    <tr>
                      <td>Copa B</td>
                      <td>78-80</td>
                      <td>83-85</td>
                      <td>88-90</td>
                      <td>93-95</td>
                      <td>98-100</td>
                      <td>103-105</td>
                      <td>108-110</td>
                      <td>113-115</td>
                    </tr>
                    <tr>
                      <td>Copa C</td>
                      <td>81-83</td>
                      <td>86-88</td>
                      <td>91-93</td>
                      <td>96-98</td>
                      <td>101-103</td>
                      <td>106-108</td>
                      <td>111-113</td>
                      <td>116-118</td>
                    </tr>
                    <tr>
                      <td>Copa D</td>
                      <td>84-86</td>
                      <td>89-91</td>
                      <td>94-96</td>
                      <td>99-101</td>
                      <td>104-106</td>
                      <td>109-111</td>
                      <td>114-116</td>
                      <td>119-121</td>
                    </tr>
                    <tr>
                      <td>Copa E</td>
                      <td>87-89</td>
                      <td>92-94</td>
                      <td>97-99</td>
                      <td>102-104</td>
                      <td>107-109</td>
                      <td>112-114</td>
                      <td>117-119</td>
                      <td>122-124</td>
                    </tr>
                    <tr>
                      <td>Copa F</td>
                      <td>90-92</td>
                      <td>95-97</td>
                      <td>100-102</td>
                      <td>105-107</td>
                      <td>111-113</td>
                      <td>115-117</td>
                      <td>120-122</td>
                      <td>125-127</td>
                    </tr>
                    <tr>
                      <td>Copa G</td>
                      <td>93-95</td>
                      <td>98-100</td>
                      <td>103-105</td>
                      <td>108-110</td>
                      <td>113-115</td>
                      <td>118-120</td>
                      <td>123-125</td>
                      <td>128-130</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Bañadores Hombre -->
              <div id="tabla-banadores-hombre-agua" class="wrapper-table table-responsive">
                <h3>Bañadores Hombre</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cintura(cm)</th>
                      <th>70-73</th>
                      <th>74-77</th>
                      <th>78-81</th>
                      <th>82-85</th>
                      <th>86-89</th>
                      <th>90-95</th>
                      <th>96-100</th>
                      <th>101-105</th>
                      <th>106-111</th>
                      <th>112-117</th>
                      <th>118-123</th>
                      <th>124-129</th>
                      <th>130-135</th>
                      <th>136-141</th>
                      <th>142-147</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>36</td>
                      <td>38</td>
                      <td>40</td>
                      <td>42</td>
                      <td>44</td>
                      <td>46</td>
                      <td>48</td>
                      <td>50</td>
                      <td>52</td>
                      <td>54</td>
                      <td>56</td>
                      <td>58</td>
                      <td>60</td>
                      <td>62</td>
                      <td>64</td>
                    </tr>
                    <tr>
                      <td>Tallas universales:</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M-L</td>
                      <td>L</td>
                      <td>L-XL</td>
                      <td>XL</td>
                      <td>XL-2XL</td>
                      <td>2XL</td>
                      <td>2XL-3XL</td>
                      <td>3XL</td>
                      <td>3XL-4XL</td>
                      <td>4XL</td>
                      <td>4XL-5XL</td>
                      <td>5XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  
              <!-- SURF -->
              <!-- Gorros Surf -->
              <div id="tabla-gorros-surf-agua" class="wrapper-table table-responsive">
                <h3>Gorros/as Surf</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Contorno cabeza(cm)</th>
                      <th>52-53</th>
                      <th>54-55</th>
                      <th>56-57</th>
                      <th>58-59</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas universales:</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Tablas Surf -->
              <div id="tabla-tablas-surf-agua" class="wrapper-table table-responsive">
                <h3>Tablas Surf</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu peso(kg)</th>
                      <th>hasta 90kg</th>
                      <th>hasta 70kg</th>
                      <th>hasta 40kg</th>
                      <th>hasta 30kg</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>8.6"</td>
                      <td>8"</td>
                      <td>7"</td>
                      <td>6"</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Neopreno Hombre Surf -->
              <div id="tabla-neopreno-hombre-surf-agua" class="wrapper-table table-responsive">
                <h3>Neopreno Hombre Surf</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu estatura(cm)</th>
                      <th>170-175</th>
                      <th>175-180</th>
                      <th>180-185</th>
                      <th>180-185</th>
                      <th>185-190</th>
                      <th>178-184</th>
                      <th>179-185</th>
                    </tr>
                    <tr>
                      <th>Tu peso(kg)</th>
                      <th>58-67</th>
                      <th>65-74</th>
                      <th>68-77</th>
                      <th>74-83</th>
                      <th>78-87</th>
                      <th>83-92</th>
                      <th>90-99</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M/L-MT</td>
                      <td>L</td>
                      <td>L/XL-LT</td>
                      <td>XL</td>
                      <td>2XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Neopreno Mujer Surf -->
              <div id="tabla-neopreno-mujer-surf-agua" class="wrapper-table table-responsive">
                <h3>Neopreno Mujer Surf</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu estatura(cm)</th>
                      <th>155-160</th>
                      <th>160-165</th>
                      <th>165-170</th>
                      <th>170-175</th>
                      <th>170-175</th>
                      <th>170-175</th>
                    </tr>
                    <tr>
                      <th>Tu peso(kg)</th>
                      <th>49-55</th>
                      <th>54-60</th>
                      <th>59-65</th>
                      <th>64-70</th>
                      <th>69-75</th>
                      <th>74-80</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>2XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Neopreno Junior Surf -->
              <div id="tabla-neopreno-junior-surf-agua" class="wrapper-table table-responsive">
                <h3>Neopreno Niños Surf</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu estatura(cm)</th>
                      <th>98-109</th>
                      <th>110-121</th>
                      <th>122-132</th>
                      <th>132-144</th>
                      <th>142-156</th>
                      <th>155-169</th>
                    </tr>
                    <tr>
                      <th>Tu peso(kg)</th>
                      <th>15-18</th>
                      <th>18-23</th>
                      <th>23-28</th>
                      <th>28-36</th>
                      <th>36-46</th>
                      <th>46-59</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>4años</td>
                      <td>6años</td>
                      <td>8años</td>
                      <td>10años</td>
                      <td>12años</td>
                      <td>14años</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  
              <!-- BODYBOARD -->
              <!-- Tablas Bodyboard -->
              <div id="tabla-tablas-bodyboard-agua" class="wrapper-table table-responsive">
                <h3>Tablas Bodyboard</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu estatura(cm)</th>
                      <th>hasta 145</th>
                      <th>hasta 165</th>
                      <th>hasta 175</th>
                      <th>hasta 185</th>
                      <th>más de 185</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>35"</td>
                      <td>38"</td>
                      <td>40"</td>
                      <td>42"</td>
                      <td>45"</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Aleta Bodyboard -->
              <div id="tabla-aleta-bodyboard-agua" class="wrapper-table table-responsive">
                <h3>Aleta Bodyboard</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Equivalencia calzado</th>
                      <th>36-38</th>
                      <th>38-40</th>
                      <th>40-42</th>
                      <th>42-44</th>
                      <th>44-46</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S</td>
                      <td>MS</td>
                      <td>M</td>
                      <td>ML</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  
              <!-- WAKEBOARD -->
              <!-- Tablas Wakeboard -->
              <div id="tabla-tablas-wakeboard-agua" class="wrapper-table table-responsive">
                <h3>Tablas Wakeboard</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu peso(kg)</th>
                      <th>menos de 75kg</th>
                      <th>desde 75kg</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas(cm):</td>
                      <td>138</td>
                      <td>143</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Botas Wakeboard -->
              <div id="tabla-botas-wakeboard-agua" class="wrapper-table table-responsive">
                <h3>Botas Wakeboard</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Largo pie(cm)</th>
                      <th>25-26</th>
                      <th>26-27</th>
                      <th>27-28</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EEUU:</td>
                      <td>7/8</td>
                      <td>8,5/9,5</td>
                      <td>10/11</td>
                    </tr>
                    <tr>
                      <td>Tallas Europa:</td>
                      <td>40/41</td>
                      <td>42/43</td>
                      <td>44/45</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  
              <!-- NATACION -->
              <!-- Neopreno Mujer -->
              <div id="tabla-neopreno-mujer-natacion-agua" class="wrapper-table table-responsive">
                <h3>Neopreno aguas abiertas Mujer</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Estatura(cm)</th>
                      <th>163</th>
                      <th>165</th>
                      <th>167</th>
                      <th>169</th>
                      <th>169,5</th>
                      <th>170</th>
                      <th>170,5</th>
                    </tr>
                    <tr>
                      <th>Perímetro pecho(cm)</th>
                      <th>80-83</th>
                      <th>84-87</th>
                      <th>88-91</th>
                      <th>92-95</th>
                      <th>96-99</th>
                      <th>100-103</th>
                      <th>04-107</th>
                    </tr>
                    <tr>
                      <th>Perímetro cintura(cm)</th>
                      <th>58-62</th>
                      <th>62-65</th>
                      <th>66-69</th>
                      <th>70-73</th>
                      <th>74-77</th>
                      <th>78-84</th>
                      <th>85-90</th>
                    </tr>
                    <tr>
                      <th>Perímetro cadera(cm)</th>
                      <th>88-90</th>
                      <th>91-93</th>
                      <th>94-97</th>
                      <th>98-101</th>
                      <th>102-107</th>
                      <th>108-111</th>
                      <th>112-116</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas universales:</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M/L</td>
                      <td>L</td>
                      <td>L/XL</td>
                      <td>XL</td>
                    </tr>
                    <tr>
                      <td>Tallas EEUU:</td>
                      <td>34</td>
                      <td>36</td>
                      <td>38</td>
                      <td>40</td>
                      <td>42</td>
                      <td>44</td>
                      <td>46</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Neopreno Hombre -->
              <div id="tabla-neopreno-hombre-natacion-agua" class="wrapper-table table-responsive">
                <h3>Neopreno aguas abiertas Hombre</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Estatura(cm)</th>
                      <th>170,5</th>
                      <th>172,5</th>
                      <th>174,5</th>
                      <th>176,5</th>
                      <th>178,5</th>
                      <th>179,5</th>
                      <th>181,5</th>
                    </tr>
                    <tr>
                      <th>Perímetro pecho(cm)</th>
                      <th>84-87</th>
                      <th>88-91</th>
                      <th>92-95</th>
                      <th>96-99</th>
                      <th>100-103</th>
                      <th>104-107</th>
                      <th>108-113</th>
                    </tr>
                    <tr>
                      <th>Perímetro cintura(cm)</th>
                      <th>70-73</th>
                      <th>74-77</th>
                      <th>78-81</th>
                      <th>82-85</th>
                      <th>86-89</th>
                      <th>90-95</th>
                      <th>96-100</th>
                    </tr>
                    <tr>
                      <th>Perímetro cadera(cm)</th>
                      <th>84-87</th>
                      <th>88-91</th>
                      <th>92-95</th>
                      <th>96-99</th>
                      <th>100-104</th>
                      <th>105-109</th>
                      <th>110-115</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas universales:</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M/L</td>
                      <td>L</td>
                      <td>L/XL</td>
                      <td>XL</td>
                    </tr>
                    <tr>
                      <td>Tallas EEUU:</td>
                      <td>34</td>
                      <td>36</td>
                      <td>38</td>
                      <td>40</td>
                      <td>42</td>
                      <td>44</td>
                      <td>46</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  
              <!-- WINDSURF -->
              <!-- Vela Windsurf -->
              <div id="tabla-velas-windsurf-agua" class="wrapper-table table-responsive">
                <h3>Velas Windsurf</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Peso(kg)</th>
                      <th>Hasta 50</th>
                      <th>50-65kg</th>
                      <th>65-75kg</th>
                      <th>Desde 80kg</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Vela (m2):</td>
                      <td>3</td>
                      <td>4,5</td>
                      <td>5,5</td>
                      <td>6,5</td>
                    </tr>
                    <tr>
                      <td>Viento (km/h):</td>
                      <td>10</td>
                      <td>40</td>
                      <td>40</td>
                      <td>20</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Mastil Botavara Windsurf -->
              <div id="tabla-mastil-windsurf-agua" class="wrapper-table table-responsive">
                <h3>Mástil y Botavara Windsurf</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Vela (m2):</th>
                      <th>3,7</th>
                      <th>4,2</th>
                      <th>4,7</th>
                      <th>5,2</th>
                      <th>5,7</th>
                      <th>6,2</th>
                      <th>6,7</th>
                      <th>7,2</th>
                      <th>8,5</th>
                    </tr>
                    <tr>
                      <th>Mástil(cm):</th>
                      <th>370</th>
                      <th>400</th>
                      <th>405</th>
                      <th>420</th>
                      <th>460</th>
                      <th>467</th>
                      <th>470</th>
                      <th>484</th>
                      <th>519</th>
                    </tr>
                    <tr>
                      <th>Botavara(cm):</th>
                      <th>155</th>
                      <th>162</th>
                      <th>170</th>
                      <th>175</th>
                      <th>185</th>
                      <th>190</th>
                      <th>200</th>
                      <th>212</th>
                      <th>230</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="special">
                      <td>Rigidez recomendada mástil (IMCS):</td>
                      <td>16</td>
                      <td>19</td>
                      <td>19</td>
                      <td>19/21</td>
                      <td>21</td>
                      <td>25/21</td>
                      <td>25</td>
                      <td>25</td>
                      <td>28</td>
                    </tr>
                    <tr style="height: 50px;">
                      <td>Longitud recomendada mástil(cm):</td>
                      <td>370</td>
                      <td>400</td>
                      <td>400</td>
                      <td>400/430</td>
                      <td>430</td>
                      <td>460</td>
                      <td>460</td>
                      <td>460</td>
                      <td>490</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
  
            <!-- DEPORTES NATURALEZA -->
            <div class="col-xs-12 wrapper-deportes-naturaleza">
              <h3 id="guia-deportes-naturaleza">Deportes Naturaleza</h3>
              <!-- Chaleco supertrack 900 -->
              <div id="tabla-chalecos-900-perro-caza" class="wrapper-table table-responsive">
                <h3>Chaleco perro supertrack 900</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Contorno cuello(cm)</th>
                      <th>21.5</th>
                      <th>23</th>
                      <th>25.5</th>
                      <th>28.5</th>
                    </tr>
                    <tr class="special">
                      <th>Longitud parte superior(cm)</th>
                      <th>33</th>
                      <th>39.5</th>
                      <th>44</th>
                      <th>49</th>
                    </tr>
                    <tr>
                      <th>Contorno riñon(cm)</th>
                      <th>18.5</th>
                      <th>19.5</th>
                      <th>21</th>
                      <th>22.5</th>
                    </tr>
                    <tr>
                      <th>Abertura pata(cm)</th>
                      <th>15.5</th>
                      <th>17.5</th>
                      <th>18</th>
                      <th>19</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Chaleco supertrack 900 -->
              <div id="tabla-chalecos-perro-caza" class="wrapper-table table-responsive">
                <h3>Chaleco perro supertrack</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Contorno cuello(cm)</th>
                      <th>39</th>
                      <th>45</th>
                      <th>49</th>
                      <th>52</th>
                    </tr>
                    <tr class="special">
                      <th>Longitud parte superior(cm)</th>
                      <th>37.5</th>
                      <th>41</th>
                      <th>42,6</th>
                      <th>44</th>
                    </tr>
                    <tr>
                      <th>Contorno riñon(cm)</th>
                      <th>38</th>
                      <th>44,5</th>
                      <th>47,9</th>
                      <th>51.5</th>
                    </tr>
                    <tr>
                      <th>Abertura pata(cm)</th>
                      <th>15</th>
                      <th>17.5</th>
                      <th>18.5</th>
                      <th>19.5</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Arnes -->
              <div id="tabla-arnes-perro-caza" class="wrapper-table table-responsive">
                <h3>Arnes perro</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Contorno cuello(cm)</th>
                      <th> max 60</th>
                      <th>max 81</th>
                      <th>max 100</th>
                    </tr>
                    <tr>
                      <th>Contorno pecho(cm)</th>
                      <th>max 70</th>
                      <th>max 102</th>
                      <th>max 110</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Chaleco supertrack 100 -->
              <div id="tabla-chalecos-100-perro-caza" class="wrapper-table table-responsive">
                <h3>Chaleco supertrack 100 perro</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Contorno cuello(cm)</th>
                      <th>17</th>
                      <th>22</th>
                      <th>23.5</th>
                    </tr>
                    <tr class="special">
                      <th>Longitud parte inferior(cm)</th>
                      <th>33</th>
                      <th>41</th>
                      <th>48</th>
                    </tr>
                    <tr>
                      <th>Longitud(cm)</th>
                      <th>26</th>
                      <th>39</th>
                      <th>44</th>
                    </tr>
                    <tr>
                      <th>Correa delantera(cm)</th>
                      <th>35</th>
                      <th>42</th>
                      <th>60</th>
                    </tr>
                    <tr>
                      <th>Correa trasera(cm)</th>
                      <th>38</th>
                      <th>44</th>
                      <th>73</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Collar supertrack 300 -->
              <div id="tabla-collar-300-perro-caza" class="wrapper-table table-responsive">
                <h3>Collar perro 300</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud(cm)</th>
                      <th>60</th>
                      <th>75</th>
                      <th>44</th>
                    </tr>
                    <tr>
                      <th>Ancho(cm)</th>
                      <th>2</th>
                      <th>2.5</th>
                    </tr>
                    <tr>
                      <th>Agujeros(cm)</th>
                      <th>20</th>
                      <th>23</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S/M</td>
                      <td>L/XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Collar supertrack 100 -->
              <div id="tabla-collar-100-perro-caza" class="wrapper-table table-responsive">
                <h3>Collar perro 100</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Largo(cm)</th>
                      <th>hasta 40</th>
                      <th>hasta 55</th>
                      <th>hasta 70</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Collar cuero -->
              <div id="tabla-collar-cuero-perro-caza" class="wrapper-table table-responsive">
                <h3>Collar perro Cuero</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud(cm)</th>
                      <th>45</th>
                      <th>60</th>
                      <th>75</th>
                    </tr>
                    <tr>
                      <th>Ancho(cm)</th>
                      <th>2</th>
                      <th>2.5</th>
                      <th>3</th>
                    </tr>
                    <tr>
                      <th>Agujeros(cm)</th>
                      <th>10</th>
                      <th>10</th>
                      <th>10</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Transportin plegable -->
              <div id="tabla-transportin-plegable-perro-caza" class="wrapper-table table-responsive">
                <h3>Transportín Plegable</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud(cm)</th>
                      <th>55</th>
                      <th>70</th>
                      <th>90</th>
                    </tr>
                    <tr>
                      <th>Ancho(cm)</th>
                      <th>38</th>
                      <th>50</th>
                      <th>60</th>
                    </tr>
                    <tr>
                      <th>Alto(cm)</th>
                      <th>38</th>
                      <th>50</th>
                      <th>60</th>
                    </tr>
                    <tr>
                      <th>Peso(kg)</th>
                      <th>2.49</th>
                      <th>3.35</th>
                      <th>4.25</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Transportin rigido -->
              <div id="tabla-transportin-rigido-1-perro-caza" class="wrapper-table table-responsive">
                <h3>Transportín Rígido 1 perro</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud(cm)</th>
                      <th>68</th>
                      <th>81</th>
                      <th>91</th>
                    </tr>
                    <tr>
                      <th>Ancho(cm)</th>
                      <th>48</th>
                      <th>55.5</th>
                      <th>61</th>
                    </tr>
                    <tr>
                      <th>Alto(cm)</th>
                      <th>45.5</th>
                      <th>58</th>
                      <th>66.5</th>
                    </tr>
                    <tr>
                      <th>Peso(kg)</th>
                      <th>3.58</th>
                      <th></th>
                      <th>11.3</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Transportin rigido 2 -->
              <div id="tabla-transportin-rigido-2-perro-caza" class="wrapper-table table-responsive">
                <h3>Transportín Rígido 2 perros</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud(cm)</th>
                      <th>85</th>
                      <th>100</th>
                    </tr>
                    <tr>
                      <th>Ancho(cm)</th>
                      <th>51</th>
                      <th>60</th>
                    </tr>
                    <tr>
                      <th>Alto(cm)</th>
                      <th>61</th>
                      <th>66</th>
                    </tr>
                    <tr>
                      <th>Peso(kg)</th>
                      <th>7.7</th>
                      <th>9.20</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Alfombrilla rigido 2 -->
              <div id="tabla-alfombrilla-perro-caza" class="wrapper-table table-responsive">
                <h3>Alfombrilla perros</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud(cm)</th>
                      <th>66</th>
                      <th>86</th>
                    </tr>
                    <tr>
                      <th>Ancho(cm)</th>
                      <th>46</th>
                      <th>56</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>M</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN -->
            </div>
  
            <!-- DEPORTES MONTAÑA -->
            <div class="col-xs-12 wrapper-deportes-montana">
              <h3 id="guia-deportes-montana">Deportes Montaña</h3>
              <!-- Botas ESQUI Junior -->
              <div id="tabla-botas-junior-ski-montana" class="wrapper-table table-responsive">
                <h3>Botas ESQUI Niños</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Mondopoint</th>
                      <th>16,5</th>
                      <th>18</th>
                      <th>18,5</th>
                      <th>19</th>
                      <th>19,5</th>
                      <th>20</th>
                      <th>21</th>
                      <th>21,5</th>
                      <th>22</th>
                      <th>22,5</th>
                      <th>23,5</th>
                      <th>24</th>
                      <th>24,5</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas Europa</td>
                      <td>26,5</td>
                      <td>28</td>
                      <td>29</td>
                      <td>30</td>
                      <td>31</td>
                      <td>32</td>
                      <td>33</td>
                      <td>34 </td>
                      <td>35</td>
                      <td>36</td>
                      <td>37</td>
                      <td>38</td>
                      <td>39</td>
                    </tr>
                    <tr>
                      <td>Tallas UK</td>
                      <td>8,5c</td>
                      <td>10c</td>
                      <td>10,5c</td>
                      <td>11,5c</td>
                      <td>12c</td>
                      <td>13c</td>
                      <td>1</td>
                      <td>1,5</td>
                      <td>2,5</td>
                      <td>3</td>
                      <td>4</td>
                      <td>5</td>
                      <td>5,5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Botas ESQUI Adulto -->
              <div id="tabla-botas-adulto-ski-montana" class="wrapper-table table-responsive">
                <h3>Botas ESQUI Adulto</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Mondopoint</th>
                      <th>22,5</th>
                      <th>23,5</th>
                      <th>24</th>
                      <th>24,5</th>
                      <th>25,5</th>
                      <th>26</th>
                      <th>27</th>
                      <th>27,5</th>
                      <th>28</th>
                      <th>28,5</th>
                      <th>29,5</th>
                      <th>30</th>
                      <th>30,5</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas Europa</td>
                      <td>36</td>
                      <td>37</td>
                      <td>38</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                      <td>43</td>
                      <td>44</td>
                      <td>45</td>
                      <td>46</td>
                      <td>47</td>
                      <td>48</td>
                    </tr>
                    <tr>
                      <td>Tallas UK</td>
                      <td>3,5</td>
                      <td>4,5</td>
                      <td>5</td>
                      <td>6</td>
                      <td>6,5</td>
                      <td>7,5</td>
                      <td>8</td>
                      <td>9</td>
                      <td>9,5</td>
                      <td>10,5</td>
                      <td>11,5</td>
                      <td>12</td>
                      <td>13</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Chaqueta hombre Barranquismo -->
              <div id="tabla-chaqueta-hombre-barranquismo-montana" class="wrapper-table table-responsive">
                <h3>Chaqueta barranquismo hombre</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Altura(cm)</th>
                      <th>169</th>
                      <th>172</th>
                      <th>176</th>
                      <th>178</th>
                      <th>181</th>
                      <th>183</th>
                    </tr>
                    <tr>
                      <th>Controno cabeza</th>
                      <th>54</th>
                      <th>54</th>
                      <th>56</th>
                      <th>56</th>
                      <th>58</th>
                      <th>58</th>
                    </tr>
                    <tr>
                      <th>Contorno pecho</th>
                      <th>84</th>
                      <th>90</th>
                      <th>96</th>
                      <th>102</th>
                      <th>112</th>
                      <th>122</th>
                    </tr>
                    <tr>
                      <th>Contorno cintura</th>
                      <th>70</th>
                      <th>76</th>
                      <th>82</th>
                      <th>88</th>
                      <th>99</th>
                      <th>110</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas Europa</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>XXL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Chaqueta hombre Barranquismo -->
              <div id="tabla-chaqueta-mujer-barranquismo-montana" class="wrapper-table table-responsive">
                <h3>Chaqueta barranquismo mujer</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Altura(cm)</th>
                      <th>165</th>
                      <th>167</th>
                      <th>169</th>
                      <th>170</th>
                      <th>171</th>
                      <th>172</th>
                    </tr>
                    <tr>
                      <th>Controno cabeza</th>
                      <th>54</th>
                      <th>54</th>
                      <th>56</th>
                      <th>56</th>
                      <th>58</th>
                      <th>58</th>
                    </tr>
                    <tr>
                      <th>Contorno pecho</th>
                      <th>85</th>
                      <th>88</th>
                      <th>92</th>
                      <th>101</th>
                      <th>110</th>
                      <th>122</th>
                    </tr>
                    <tr>
                      <th>Contorno cintura</th>
                      <th>65</th>
                      <th>68</th>
                      <th>71</th>
                      <th>83</th>
                      <th>95</th>
                      <th>107</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas Europa</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>XXL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Barranquismo -->
              <div id="tabla-guantes-barranquismo-montana" class="wrapper-table table-responsive">
                <h3>Guantes barranquismo</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Ancho mano(cm)</th>
                      <th>8.9</th>
                      <th>9.3</th>
                      <th>9.6</th>
                      <th>10</th>
                      <th>10.35</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas Europa</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>XXL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Escarpines Barranquismo -->
              <div id="tabla-escarpines-barranquismo-montana" class="wrapper-table table-responsive">
                <h3>Escarpines barranquismo</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Pie(cm)</th>
                      <th>23-23.7</th>
                      <th>24-25</th>
                      <th>25.4-26</th>
                      <th>26.5-27.9</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas Europa</td>
                      <td>38-39</td>
                      <td>40-41</td>
                      <td>42-43</td>
                      <td>44-45</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Cascos Escalada -->
              <div id="tabla-cascos-escalada-montana" class="wrapper-table table-responsive">
                <h3>Cascos escalada</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro(cm)</th>
                      <th>50-57</th>
                      <th>58-61</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>M</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Arnes Escalada -->
              <div id="tabla-arnes-escalada-montana" class="wrapper-table table-responsive">
                <h3>Arnes escalada</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Easy</th>
                      <th>Contorno cintura(cm)</th>
                      <th>65-90</th>
                      <th>82-110</th>
                    </tr>
                    <tr>
                      <th>Easy</th>
                      <th>Contorno muslo(cm)</th>
                      <th>32-60</th>
                      <th>35-70</th>
                    </tr>
                    <tr>
                      <th>Easy Junior</th>
                      <th>Contorno cintura(cm)</th>
                      <th>52-76</th>
                    </tr>
                    <tr>
                      <th>Easy Junior</th>
                      <th>Contorno muslo(cm)</th>
                      <th>25-45</th>
                    </tr>
                    <tr>
                      <th>Rock</th>
                      <th>Contorno cintura(cm)</th>
                      <th>70-95</th>
                      <th>84-117</th>
                    </tr>
                    <tr>
                      <th>Rock</th>
                      <th>Contorno muslo(cm)</th>
                      <th>48-58</th>
                      <th>57-67</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td></td>
                      <td>S-M</td>
                      <td>L-2XL</td>
                    </tr>
                  </tbody>
                </table>
                </div>
                <div id="tabla-arnes-escalada-montana" class="wrapper-table table-responsive">
                <h3 style="margin-top:25px;">Edge</h3>
                <table style="margin-top:5rem;" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Contorno cintura(cm)</th>
                      <th>69-74</th>
                      <th>74-79</th>
                      <th>79-84</th>
                      <th>84-89</th>
                      <th>89-94</th>
                    </tr>
                    <tr>
                      <th>Contorno muslo(cm)</th>
                      <th>46-52</th>
                      <th>49-55</th>
                      <th>52-58</th>
                      <th>54-60</th>
                      <th>56-62</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Pies de gato Adulto Escalada -->
              <div id="tabla-pies-gato-adulto-escalada-montana" class="wrapper-table table-responsive">
                <h3>Pies de gato adulto escalada</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Pie(cm)</th>
                      <th>21,5</th>
                      <th>22</th>
                      <th>22,5</th>
                      <th>23</th>
                      <th>23,5</th>
                      <th>24</th>
                      <th>24,5</th>
                      <th>25,5</th>
                      <th>26</th>
                      <th>26,5</th>
                      <th>27,5</th>
                      <th>28</th>
                      <th>29,5</th>
                      <th>30</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>34</td>
                      <td>35</td>
                      <td>36</td>
                      <td>37</td>
                      <td>38</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                      <td>43</td>
                      <td>44</td>
                      <td>45</td>
                      <td>46</td>
                      <td>47</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Pies de gato Junioe Escalada -->
              <div id="tabla-pies-gato-junior-escalada-montana" class="wrapper-table table-responsive">
                <h3>Pies de gato junior escalada</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Pie(cm)</th>
                      <th>18</th>
                      <th>18,5</th>
                      <th>19</th>
                      <th>19,5</th>
                      <th>20</th>
                      <th>21</th>
                      <th>21,5</th>
                      <th>22</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>28</td>
                      <td>29</td>
                      <td>30</td>
                      <td>31</td>
                      <td>32</td>
                      <td>33</td>
                      <td>34</td>
                      <td>35</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN -->
            </div>
  
            <!-- DEPORTES COLECTIVOS -->
            <div class="col-xs-12 wrapper-deportes-colectivos">
              <h3 id="guia-deportes-colectivos">Deportes Colectivos</h3>
              <!-- Botas futbol Mujer -->
              <div id="tabla-botas-mujer-futbol" class="wrapper-table table-responsive">
                <h3>Botas de fútbol Mujer</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>20.9 - 21.5</th>
                      <th>21.6 - 22.2</th>
                      <th>22.3 - 22.8</th>
                      <th>22.9 - 23.5</th>
                      <th>23.6 - 24.2</th>
                      <th>24.3 - 24.9</th>
                      <th>25 - 25.6</th>
                      <th>25.7 - 26.2</th>
                      <th>26.3 - 26.8</th>
                      <th>26.9 - 27.5</th>
                      <th>27.6 - 28.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>34</td>
                      <td>35</td>
                      <td>36</td>
                      <td>37</td>
                      <td>38</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                      <td>43</td>
                      <td>44</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>3</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                      <td>10</td>
                      <td>11</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>1.5</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>4</td>
                      <td>5</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- ½ tallas disponibles para algunos productos -->
              <div id="tabla-botas-medios-mujer-futbol" class="wrapper-table table-responsive">
                <h3>½ tallas disponibles para algunos productos</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>21.4 - 21.6</th>
                      <th>22.9 - 23.1</th>
                      <th>23.4 - 23.6</th>
                      <th>24.9 - 25.1</th>
                      <th>26.4 - 26.6</th>
                      <th>27.4 - 27.6</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU :</td>
                      <td>34½</td>
                      <td>36½</td>
                      <td>37½</td>
                      <td>39½</td>
                      <td>41½</td>
                      <td>43½</td>
                    </tr>
                    <tr>
                      <td>Tallas US :</td>
                      <td>3.5</td>
                      <td>5</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                      <td>10.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK :</td>
                      <td>2</td>
                      <td>3.5</td>
                      <td>4.5</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Botas de fútbol Hombre -->
              <div id="tabla-botas-hombre-futbol" class="wrapper-table table-responsive">
                <h3>Botas de fútbol Hombre</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>24.3 - 24.9</th>
                      <th>25 - 25.6</th>
                      <th>25.7 - 26.2</th>
                      <th>26.3 - 26.8</th>
                      <th>26.9 - 27.5</th>
                      <th>27.6 - 28.2</th>
                      <th>28.3 - 28.8</th>
                      <th>28.9 - 29.5</th>
                      <th>29.6 - 30.2</th>
                      <th>30.3 - 30.8</th>
                      <th>30.9 - 31.5</th>
                      <th>31.6 - 32.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                      <td>43</td>
                      <td>44</td>
                      <td>45</td>
                      <td>46</td>
                      <td>47</td>
                      <td>48</td>
                      <td>49</td>
                      <td>50</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>6</td>
                      <td>7</td>
                      <td>7.5</td>
                      <td>8.5</td>
                      <td>9</td>
                      <td>10</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>14</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>5.5</td>
                      <td>6.5</td>
                      <td>7</td>
                      <td>8</td>
                      <td>8.5</td>
                      <td>9.5</td>
                      <td>10.5</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- ½ tallas disponibles para algunos productos -->
              <div id="tabla-botas-medios-hombre-futbol" class="wrapper-table table-responsive">
                <h3>½ tallas disponibles para algunos productos</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud pie(cm)</th>
                      <th>24.9 - 25.1</th>
                      <th>26.4 - 26.6</th>
                      <th>27.4 - 27.6</th>
                      <th>28.4 - 28.6</th>
                      <th>30.4 - 30.6</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU :</td>
                      <td>39½</td>
                      <td>41½</td>
                      <td>43½</td>
                      <td>44½</td>
                      <td>47½</td>
                    </tr>
                    <tr>
                      <td>Tallas US :</td>
                      <td>6.5</td>
                      <td>8</td>
                      <td>9.5</td>
                      <td>10.5</td>
                      <td>12.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK :</td>
                      <td>6</td>
                      <td>7.5</td>
                      <td>9</td>
                      <td>10</td>
                      <td>12</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Botas de fútbol Junior -->
              <div id="tabla-botas-junior-futbol" class="wrapper-table table-responsive">
                <h3>Botas de fútbol 0-16 años</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Longitud de pie(cm)</th>
                      <th>17.6 - 18.2</th>
                      <th>18.9 - 19.1</th>
                      <th>18.3 - 18.8</th>
                      <th>18.9 - 19.5</th>
                      <th>19.9 - 20.1</th>
                      <th>19.6 - 20.2</th>
                      <th>20.4 - 20.6</th>
                      <th>20.3 - 20.8</th>
                      <th>20.9 - 21.5</th>
                      <th>21.4 - 21.6</th>
                      <th>21.6 - 22.2</th>
                      <th>22.3 - 22.8</th>
                      <th>22.9 - 23.1</th>
                      <th>22.9 - 23.5</th>
                      <th>23.4 - 23.6</th>
                      <th>23.6 - 24.2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas EU:</td>
                      <td>29</td>
                      <td>29½</td>
                      <td>30</td>
                      <td>31</td>
                      <td>31½</td>
                      <td>32</td>
                      <td>32½</td>
                      <td>33</td>
                      <td>34</td>
                      <td>34½</td>
                      <td>35</td>
                      <td>36</td>
                      <td>36½</td>
                      <td>37</td>
                      <td>37½</td>
                      <td>38</td>
                    </tr>
                    <tr>
                      <td>Tallas US:</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>1</td>
                      <td>1.5</td>
                      <td>2</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>3.5</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5</td>
                      <td>5.5</td>
                    </tr>
                    <tr>
                      <td>Tallas UK:</td>
                      <td>10.5</td>
                      <td>11</td>
                      <td>11.5</td>
                      <td>12</td>
                      <td>12.5</td>
                      <td>13</td>
                      <td>13.5</td>
                      <td>1</td>
                      <td>1.5</td>
                      <td>2</td>
                      <td>2.5</td>
                      <td>3</td>
                      <td>3.5</td>
                      <td>4</td>
                      <td>4.5</td>
                      <td>5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN JUNIOR -->
            </div>
  
            <!-- FITNESS, BAILE, COMBATE -->
            <div class="col-xs-12 wrapper-fitness-baile-combate">
              <h3 id="guia-fitness-baile-combate-esgrima">Fitness, Baile, Combate, Esgrima</h3>
              <div id="tabla-caretas-espada" class="wrapper-table table-responsive">
                     <!-- Caretas Esgrima -->
                <h3>Careta de espada</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tallas</th>
                      <th>Altura de la cabeza</th>
                      <th>Ancho de la cabeza</th>
                      <th>Profundidad de la cabeza</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>XS</td>
                      <td>25cm</td>
                      <td>18cm</td>
                      <td>22cm</td>
                    </tr> 
                    <tr>
                      <td>S</td>
                      <td>27cm</td>
                      <td>18.5cm</td>
                      <td>22cm</td>
                    </tr> 
                    <tr>
                      <td>M</td>
                      <td>27.5cm</td>
                      <td>19cm</td>
                      <td>22cm</td>
                    </tr>
                    <tr>
                      <td>L</td>
                      <td>28cm</td>
                      <td>19.5cm</td>
                      <td>22cm</td>
                    </tr>  
                    <tr>
                      <td>XL</td>
                      <td>29cm</td>
                      <td>20cm</td>
                      <td>22cm</td>
                    </tr> 
                  </tbody>
                </table>
              </div>
              <div id="tabla-caretas-espada" class="wrapper-table table-responsive">
                  <!-- Caretas Esgrima -->
             <h3>Careta de sable</h3>
             <table class="table table-bordered">
               <thead>
                 <tr>
                   <th>Tallas</th>
                   <th>Altura de la cabeza</th>
                   <th>Ancho de la cabeza</th>
                   <th>Profundidad de la cabeza</th>
                 </tr>
               </thead>
               <tbody>
                 <tr>
                   <td>XS</td>
                   <td>25cm</td>
                   <td>18cm</td>
                   <td>22cm</td>
                 </tr> 
                 <tr>
                   <td>S</td>
                   <td>27cm</td>
                   <td>18.5cm</td>
                   <td>22cm</td>
                 </tr> 
                 <tr>
                   <td>M</td>
                   <td>27.5cm</td>
                   <td>19cm</td>
                   <td>22cm</td>
                 </tr>
                 <tr>
                   <td>L</td>
                   <td>28cm</td>
                   <td>19.5cm</td>
                   <td>22cm</td>
                 </tr>  
                 <tr>
                   <td>XL</td>
                   <td>29cm</td>
                   <td>20cm</td>
                   <td>22cm</td>
                 </tr> 
               </tbody>
             </table>
           </div>
           <div id="tabla-calleras-gimnasia-artistica" class="wrapper-table table-responsive">
            <!-- Calleras gimnasia artística -->
          <h3>Calleras gimnasia artística</h3>
          <table class="table table-bordered">
            <thead>
             <tr>
              <th>Tallas</th>
              <th>Barras asimétricas</th>
              <th>Anillas</th>
              <th>Barra fija</th>
            </tr>
            </thead>
          <tbody>
            <tr>
              <td>0</td>
              <td>&lt; 13.7cm</td>
              <td>&lt; 14cm</td>
              <td>&lt; 11.3cm</td>
            </tr> 
            <tr>
              <td>1</td>
              <td>&lt; 14.4cm</td>
              <td>&lt; 15cm</td>
              <td>&lt; 12.6cm</td>
            </tr> 
            <tr>
              <td>2</td>
              <td>&lt; 15.2cm</td>
              <td>&lt; 16cm</td>
              <td>&lt; 13.9cm</td>
            </tr>
            <tr>
              <td>3</td>
              <td>&lt; 16cm</td>
              <td>&lt; 17cm</td>
              <td>&lt; 15.3cm</td>
            </tr>  
            </tbody>
          </table>
          </div>
              <!-- Guantes Boxeo Hombre -->
              <div id="tabla-guantes-hombre-boxeo" class="wrapper-table table-responsive">
                <h3>Guantes Boxeo Hombre</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu peso(kg)</th>
                      <th>45 - 60</th>
                      <th>60 - 80</th>
                      <th>80 - 90</th>
                      <th>90 - 100</th>
                      <th>100</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>8 oz</td>
                      <td>10 oz</td>
                      <td>12 oz</td>
                      <td>14 oz</td>
                      <td>16 oz</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Boxeo Mujer -->
              <div id="tabla-guantes-mujer-boxeo" class="wrapper-table table-responsive">
                <h3>Guantes Boxeo Mujer</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu peso(kg)</th>
                      <th>45 - 60</th>
                      <th>60 - 80</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>8 oz</td>
                      <td>10 oz</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Boxeo Junior -->
              <div id="tabla-guantes-junior-boxeo" class="wrapper-table table-responsive">
                <h3>Guantes Boxeo Niños</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu peso(kg)</th>
                      <th>20 - 25</th>
                      <th>25 - 45</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>6 oz</td>
                      <td>8 oz</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Pegada Hombre -->
              <div id="tabla-guantes-pegada-hombre-boxeo" class="wrapper-table table-responsive">
                <h3>Guantes Pegada Hombre</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(kg)</th>
                      <th>20.86-21.5</th>
                      <th>21.51-22.15</th>
                      <th>22.16-22.8</th>
                      <th>22.81-23.45</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Pegada Mujer -->
              <div id="tabla-guantes-pegada-mujer-boxeo" class="wrapper-table table-responsive">
                <h3>Guantes Pegada Mujer</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro mano(kg)</th>
                      <th>17.96-18.8</th>
                      <th>18.81-19.5</th>
                      <th>19.51-20.1</th>
                      <th>20.11-20.7</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Guantes Pegada Mujer -->
              <div id="tabla-kimonos-combate" class="wrapper-table table-responsive">
                <h3>Kimonos</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Estatura(cm)</th>
                      <th>90-95</th>
                      <th>100-105</th>
                      <th>110-115</th>
                      <th>120-125</th>
                      <th>130-135</th>
                      <th>140-145</th>
                      <th>150-155</th>
                      <th>160-165</th>
                      <th>170-175</th>
                      <th>180-185</th>
                      <th>190-195</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>100</td>
                      <td>110</td>
                      <td>120</td>
                      <td>130</td>
                      <td>140</td>
                      <td>150</td>
                      <td>160</td>
                      <td>170</td>
                      <td>180</td>
                      <td>190</td>
                      <td>200</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Arañas Danza -->
              <div id="tabla-aranas-danza" class="wrapper-table table-responsive">
                <h3>Arañas danza</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Pie(cm)</th>
                      <th>35/36</th>
                      <th>37/38</th>
                      <th>39/41</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Rodilleras Danza -->
              <div id="tabla-rodilleras-danza" class="wrapper-table table-responsive">
                <h3>Rodilleras danza</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Contorno rodilla(cm)</th>
                      <th>30-33</th>
                      <th>33-36</th>
                      <th>36-39</th>
                      <th>39-43</th>
                      <th>43-47</th>
                      <th>47-51</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Medias Danza Clásica niña-->
              <div id="tabla-medias-danza" class="wrapper-table table-responsive">
                <h3>Medias Danza Clásica Niña</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Estatura(cm)</th>
                      <th>98-104</th>
                      <th>115-124</th>
                      <th>125-132</th>
                      <th>133-142</th>
                      <th>143-150</th>
                      <th>151-160</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>4 años</td>
                      <td>6 años</td>
                      <td>8 años</td>
                      <td>10 años</td>
                      <td>12 años</td>
                      <td>14 años</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FALDAS DANZA CLÁSICA NIÑA-->
              <div id="tabla-faldas-danza" class="wrapper-table table-responsive">
                <h3>Faldas Danza Clásica Niña</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Estatura(cm)</th>
                      <th>98-104</th>
                      <th>115-124</th>
                      <th>125-132</th>
                      <th>133-142</th>
                      <th>143-150</th>
                      <th>151-160</th>
                      <th>161-169</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>4 años</td>
                      <td>6 años</td>
                      <td>8 años</td>
                      <td>10 años</td>
                      <td>12 años</td>
                      <td>14 años</td>
                      <td>16 años</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- MAILLOTS DANZA CLÁSICA NIÑA-->
              <div id="tabla-maillots-danza" class="wrapper-table table-responsive">
                <h3>Maillots Danza Clásica Niña</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Estatura(cm)</th>
                      <th>98-104</th>
                      <th>115-124</th>
                      <th>125-132</th>
                      <th>133-142</th>
                      <th>143-150</th>
                      <th>151-160</th>
                      <th>161-169</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>4 años</td>
                      <td>6 años</td>
                      <td>8 años</td>
                      <td>10 años</td>
                      <td>12 años</td>
                      <td>14 años</td>
                      <td>16 años</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- CHAQUETAS DANZA CLÁSICA NIÑA -->
              <div id="tabla-chaquetas-danza" class="wrapper-table table-responsive">
                <h3>Chaquetas Danza Clásica Niña</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Estatura(cm)</th>
                      <th>98-104</th>
                      <th>115-124</th>
                      <th>125-132</th>
                      <th>133-142</th>
                      <th>143-150</th>
                      <th>151-160</th>
                      <th>161-169</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>4 años</td>
                      <td>6 años</td>
                      <td>8 años</td>
                      <td>10 años</td>
                      <td>12 años</td>
                      <td>14 años</td>
                      <td>16 años</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- PUNTAS DANZA CLÁSICA -->
              <div id="tabla-puntas-danza" class="wrapper-table table-responsive">
                <h3>Puntas Danza Clásica</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Pie(cm)</th>
                      <th>21</th>
                      <th>21,5</th>
                      <th>22</th>
                      <th>22,5</th>
                      <th>23,5</th>
                      <th>24</th>
                      <th>24,5</th>
                      <th>25,5</th>
                      <th>26</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>33</td>
                      <td>34</td>
                      <td>35</td>
                      <td>36</td>
                      <td>37</td>
                      <td>38</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- ZAPATILLAS MEDIA PUNTA DANZA CLÁSICA -->
              <div id="tabla-mediapunta-danza" class="wrapper-table table-responsive">
                <h3>Zapatillas media punta Danza Clásica</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Pie(cm)</th>
                      <th>15,5</th>
                      <th>16,5</th>
                      <th>17</th>
                      <th>18</th>
                      <th>18,5</th>
                      <th>19</th>
                      <th>19,5</th>
                      <th>20</th>
                      <th>21</th>
                      <th>21,5</th>
                      <th>22</th>
                      <th>22,5</th>
                      <th>23,5</th>
                      <th>24</th>
                      <th>24,5</th>
                      <th>25,5</th>
                      <th>26</th>
                      <th>26,5</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>25</td>
                      <td>26</td>
                      <td>27</td>
                      <td>28</td>
                      <td>29</td>
                      <td>30</td>
                      <td>31</td>
                      <td>32</td>
                      <td>33</td>
                      <td>34</td>
                      <td>35</td>
                      <td>36</td>
                      <td>37</td>
                      <td>38</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- ZAPATILLAS DE DANZA JAZZ -->
              <div id="tabla-zapatillas-jazz" class="wrapper-table table-responsive">
                <h3>ZAPATILLAS DE DANZA JAZZ</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Pie(cm)</th>
                      <th>19</th>
                      <th>19,5</th>
                      <th>20</th>
                      <th>21</th>
                      <th>21,5</th>
                      <th>22</th>
                      <th>22,5</th>
                      <th>23,5</th>
                      <th>24</th>
                      <th>24,5</th>
                      <th>22,5</th>
                      <th>26</th>
                      <th>26,5</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>30</td>
                      <td>31</td>
                      <td>32</td>
                      <td>33</td>
                      <td>34</td>
                      <td>35</td>
                      <td>36</td>
                      <td>37</td>
                      <td>38</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- SUJETADOR DANZA CLÁSICA MUJER -->
              <div id="tabla-sujetador-danza" class="wrapper-table table-responsive">
                <h3>SUJETADOR DANZA CLÁSICA MUJER</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro pecho(cm)</th>
                      <th>80-83</th>
                      <th>84-87</th>
                      <th>88-91</th>
                      <th>92-95</th>
                      <th>96-99</th>
                      <th>100-103</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas:</td>
                      <td>2XS</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>M-L</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN  -->
            </div>
  
            <!-- EQUITACION -->
            <div class="col-xs-12 wrapper-equitacion">
              <h3 id="guia-equitacion">Equitación</h3>
              <!-- Gorra -->
              <div id="tabla-gorras-equitacion" class="wrapper-table table-responsive">
                <h3>Gorras</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro cabeza(cm)</th>
                      <th>48 - 51</th>
                      <th>52 - 55</th>
                      <th>56 - 60</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Polainas -->
              <div id="tabla-polainas-adulto-equitacion" class="wrapper-table table-responsive">
                <h3>Polainas adulto</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro gemelo(cm)</th>
                      <th>30.5 - 31.5</th>
                      <th>31 - 33.9</th>
                      <th>31 - 33.9</th>
                      <th>34 - 36.9</th>
                      <th>37 - 39.9</th>
                      <th>31 - 33.9</th>
                      <th>34 - 36.9</th>
                      <th>37 - 39.9</th>
                      <th>40 - 43</th>
                    </tr>
                    <tr>
                      <th>Altura caña(cm)</th>
                      <th>25.5 - 30.4</th>
                      <th>30.5 - 33.9</th>
                      <th>34 - 37.9</th>
                      <th>34 - 37.9</th>
                      <th>34 - 37.9</th>
                      <th>38 - 42</th>
                      <th>38 - 42</th>
                      <th>38 - 42 </th>
                      <th>38 - 42</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>S-28</td>
                      <td>S-32</td>
                      <td>S-36</td>
                      <td>M-36</td>
                      <td>L36</td>
                      <td>S-39</td>
                      <td>M-39</td>
                      <td>L-39</td>
                      <td>XL-39</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Mini-chaps -->
              <div id="tabla-mini-chaps-equitacion" class="wrapper-table table-responsive">
                <h3>Mini-Chaps Niños</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Perímetro gemelo(cm)</th>
                      <th>26 - 29</th>
                      <th>27.5 - 30.5</th>
                      <th>27.5 - 30.5</th>
                      <th>28 - 31</th>
                    </tr>
                    <tr>
                      <th>Altura caña(cm)</th>
                      <th>17 - 20.9</th>
                      <th>21 - 25.4</th>
                      <th>25.5 - 30.4</th>
                      <th>30.5 - 34</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>4 ans</td>
                      <td>6 ans</td>
                      <td>8 ans</td>
                      <td>10 ans</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Bridón -->
              <div id="tabla-bridon-equitacion" class="wrapper-table">
                <h3>Bridón</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Montura</th>
                      <th>Shetland (SHT)</th>
                      <th>Poney (PS)</th>
                      <th>Caballo pequeño</th>
                      <th>Caballo (FS)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>85-95 cm</td>
                      <td>90-105 cm</td>
                      <td>95-115 cm</td>
                      <td>100-125 cm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Correa -->
              <div id="tabla-correa-equitacion" class="wrapper-table table-responsive">
                <h3>Correa</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th style="height: 37px;"></th>
                      <th colspan="6">Perímetro cuello(cm)</th>
                    </tr>
                    <tr>
                      <th class="bg-grey">Altura(cm)</th>
                      <th>-65</th>
                      <th>65 / 75</th>
                      <th>75 / 85</th>
                      <th>85 / 95</th>
                      <th>95 / 105</th>
                      <th>105 / 115</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="height: 36px;">
                      <td class="bg-grey">- 100</td>
                      <td class="bg-yellow"></td>
                      <td class="bg-yellow"></td>
                      <td class="bg-yellow"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-green"></td>
                      <td class="bg-green"></td>
                    </tr>
                    <tr style="height: 36px;">
                      <td class="bg-grey">110</td>
                      <td class="bg-yellow"></td>
                      <td class="bg-yellow"></td>
                      <td class="bg-yellow"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-green"></td>
                      <td class="bg-green"></td>
                    </tr>
                    <tr style="height: 36px;">
                      <td class="bg-grey">120</td>
                      <td class="bg-yellow"></td>
                      <td class="bg-yellow"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-green"></td>
                      <td class="bg-green"></td>
                    </tr>
                    <tr style="height: 36px;">
                      <td class="bg-grey">130</td>
                      <td class="bg-yellow"></td>
                      <td class="bg-yellow">T1</td>
                      <td class="bg-pink"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-green"></td>
                      <td class="bg-green"></td>
                    </tr>
                    <tr style="height: 36px;">
                      <td class="bg-grey">140</td>
                      <td class="bg-yellow"></td>
                      <td class="bg-yellow"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-pink">T2</td>
                      <td class="bg-green"></td>
                      <td class="bg-green"></td>
                    </tr>
                    <tr style="height: 36px;">
                      <td class="bg-grey">150</td>
                      <td class="bg-yellow"></td>
                      <td class="bg-yellow"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-green">T3</td>
                      <td class="bg-green"></td>
                    </tr>
                    <tr style="height: 36px;">
                      <td class="bg-grey">160</td>
                      <td class="bg-yellow"></td>
                      <td class="bg-yellow"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-green"></td>
                      <td class="bg-green"></td>
                      <td class="bg-green"></td>
                    </tr>
                    <tr style="height: 36px;">
                      <td class="bg-grey">170</td>
                      <td class="bg-yellow"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-pink"></td>
                      <td class="bg-green"></td>
                      <td class="bg-green"></td>
                      <td class="bg-green"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Manta -->
              <div id="tabla-manta-equitacion" class="wrapper-table table-responsive">
                <h3>Manta</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Montura</th>
                      <th>Shetland / Poney B</th>
                      <th>Poney</th>
                      <th>Poney D</th>
                      <th>Caballo pequeño</th>
                      <th>Caballo mediano</th>
                      <th>Caballo grande</th>
                      <th>Caballo muy grande</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="special">Altura a la cruz</td>
                      <td>110-120 cm</td>
                      <td>120-130 cm</td>
                      <td>130-150 cm</td>
                      <td>150-160 cm</td>
                      <td>160-170 cm</td>
                      <td>170-180 cm</td>
                      <td>180 cm y más</td>
                    </tr>
                    <tr class="special">
                      <td class="special">Talla a elegir = longitud de dorso</td>
                      <td>105 cm</td>
                      <td>115 cm</td>
                      <td>125 cm</td>
                      <td>135 cm</td>
                      <td>145 cm</td>
                      <td>155 cm</td>
                      <td>165 cm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Campanas -->
              <div id="tabla-campanas-equitacion" class="wrapper-table table-responsive">
                <h3>Campanas</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Montura</th>
                      <th>Shetland / Poney B</th>
                      <th>Poney C / D </th>
                      <th>Caballo pequeño</th>
                      <th>Caballo mediano</th>
                      <th>Caballo grande</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Protecciones -->
              <div id="tabla-protecciones-equitacion" class="wrapper-table table-responsive">
                <h3>Protecciones</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Montura</th>
                      <th>Shetland</th>
                      <th>Poney</th>
                      <th>Caballo pequeño</th>
                      <th>Caballo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>SHT</td>
                      <td>PS</td>
                      <td>CS</td>
                      <td>FS</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- FIN JUNIOR -->
            </div>
            <!-- TRIATLÓN -->
            <div class="col-xs-12 wrapper-triatlon">
              <h3 id="guia-triatlon">TRIATLÓN</h3>
              <!-- NEOPRENOS TRIATLÓN -->
              <div id="tabla-neoprenotri-hombre" class="wrapper-table table-responsive">
                <h3>NEOPRENOS TRIATLÓN HOMBRE Y MUJER</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Contorno pecho(cm)</th>
                      <th>84-87</th>
                      <th>88-91</th>
                      <th>92-95</th>
                      <th>100-103</th>
                      <th>108-113</th>
                      <th>119-123</th>
                    </tr>
                    <tr>
                      <th>Talla Europa</th>
                      <th>36</th>
                      <th>38</th>
                      <th>40</th>
                      <th>44</th>
                      <th>48</th>
                      <th>52</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>XXL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- NEOPRENOS TRIATLÓN NIÑOS -->
              <div id="tabla-ninostri-neopreno" class="wrapper-table table-responsive">
                <h3>NEOPRENOS TRIATLÓN NIÑOS</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tu Estatura(cm)</th>
                      <th>126-136</th>
                      <th>132-147</th>
                      <th>146-162</th>
                    </tr>
                    <tr>
                      <th>Tu Peso (kg)</th>
                      <th>26-32</th>
                      <th>30-40</th>
                      <th>40-50</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- TRITRAJES ADULTO -->
              <div id="tabla-tritaje-adulto" class="wrapper-table table-responsive">
                <h3>TRITRAJES ADULTO</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Diámetro cintura(cm)</th>
                      <th>84-87</th>
                      <th>88-91</th>
                      <th>92-95</th>
                      <th>96-103</th>
                      <th>104-113</th>
                      <th>114-123</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>XS</td>
                      <td>S</td>
                      <td>M</td>
                      <td>L</td>
                      <td>XL</td>
                      <td>XXL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- CALZADO CICLISMO TRIATLÓNS -->
              <div id="tabla-tritaje-adulto" class="wrapper-table table-responsive">
                <h3>CALZADO CICLISMO TRIATLÓN</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Pie(cm)</th>
                      <th>24,5</th>
                      <th>25,2</th>
                      <th>25,8</th>
                      <th>26,5</th>
                      <th>27,2</th>
                      <th>27,8</th>
                      <th>28,5</th>
                      <th>29,2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>39</td>
                      <td>40</td>
                      <td>41</td>
                      <td>42</td>
                      <td>43</td>
                      <td>44</td>
                      <td>45</td>
                      <td>46</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- CALCETINES COMPRESIÓN -->
              <div id="tabla-calcetines-compresion" class="wrapper-table table-responsive">
                <h3>CALCETINES COMPRESIÓN</h3>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Pie(cm)</th>
                      <th>22/24</th>
                      <th>24,5/27</th>
                      <th>27,5/29,5</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Tallas</td>
                      <td>35/38</td>
                      <td>39/42</td>
                      <td>43/46</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
             <!-- HOCKEY -->
            <div class="col-xs-12 wrapper-hockey">
                <h3 id="guia-hockey">Hockey</h3>
                <!-- ESPINILLERAS -->
                <div id="tabla-espinilleras" class="wrapper-table table-responsive">
                    <h3>Espinilleras</h3>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Talla</th>
                          <th>S-13"</th>
                          <th>M-14"</th>
                          <th>L-15"</th>
                          <th>XL-16"</th>
                          <th>XXL-17"</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Altura Jugador</td>
                          <td>1,65-1,75</td>
                          <td>1,70-1,80</td>
                          <td>1,75-1,85</td>
                          <td>1,80-1,90</td>
                          <td>1,85-1,98</td>
                        </tr>
                        <tr>
                          <td>Longitud de la tibia</td>
                          <td>30-33</td>
                          <td>33-36</td>
                          <td>36-38</td>
                          <td>38-41</td>
                          <td>41-43</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </body>
  </html>
  `;
};



// WEBPACK FOOTER //
// ./src/_override/shared/pdp/size-guide/templateSizeGuide.js